// AFTER
export const TikTokIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="32"
      width="32"
      viewBox="0 0 32 32"
    >
      <path
        fill="#FAFAFA"
        d="M24.1,14.3c-1.6,0-3.1-.5-4.4-1.4v6.5c0,3.2-2.6,5.9-5.9,5.9-3.2,0-5.9-2.6-5.9-5.9,0-3.2,2.6-5.9,5.9-5.9.3,0,.5,0,.8,0v3.3c-1.4-.4-2.9.3-3.4,1.8-.4,1.4.3,2.9,1.8,3.4,1.4.4,2.9-.3,3.4-1.8,0-.3.1-.5.1-.8V6.7h3.2c0,.3,0,.5,0,.8h0c.2,1.2.9,2.2,1.9,2.9.7.5,1.6.7,2.4.7v3.2Z"
      />
    </svg>
  );
};

// FACEBOOK ICON
export const FacebookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
    >
      <g clipPath="url(#clip0_303_1562)">
        <path
          d="M28.0547 0.474609H4.05469C1.84869 0.474609 0.0546875 2.26861 0.0546875 4.47461V28.4746C0.0546875 30.6806 1.84869 32.4746 4.05469 32.4746H28.0547C30.2607 32.4746 32.0547 30.6806 32.0547 28.4746V4.47461C32.0547 2.26861 30.2607 0.474609 28.0547 0.474609Z"
          fill="blue"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.0547 16.4746H22.0547V12.4746C22.0547 11.3706 22.9507 11.4746 24.0547 11.4746H26.0547V6.47461H22.0547C20.4634 6.47461 18.9373 7.10675 17.812 8.23197C16.6868 9.35719 16.0547 10.8833 16.0547 12.4746V16.4746H12.0547V21.4746H16.0547V32.4746H22.0547V21.4746H25.0547L27.0547 16.4746Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_303_1562">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.0546875 0.474609)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// WHITE FACEBOOK ICON
export const WhiteFacebookIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#FAFAFA00" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 14H17.6667V11.3333C17.6667 10.5973 18.264 10.6666 19 10.6666H20.3333V7.33331H17.6667C16.6058 7.33331 15.5884 7.75474 14.8382 8.50489C14.0881 9.25503 13.6667 10.2724 13.6667 11.3333V14H11V17.3333H13.6667V24.6666H17.6667V17.3333H19.6667L21 14Z"
        fill="#FAFAFA"
      />

      <defs>
        <clipPath id="clip0_1081_705">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// TWITTER ICON
export const TwitterIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="5" fill="black" />
      <path
        d="M10.4311 11L17.8563 20.928L10.3843 29H12.0661L18.6079 21.9327L23.8934 29H29.6162L21.773 18.5136L28.728 11H27.0462L21.0217 17.5086L16.1538 11H10.4311ZM12.9042 12.2387H15.5332L27.1427 27.7613H24.5137L12.9042 12.2387Z"
        fill="white"
      />
    </svg>
  );
};

// WHITE Twitter ICON
export const WhiteTwitterIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="#FAFAFA"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#FAFAFA00" />
      <path
        d="M8.34505 8.79999L14.2852 16.7424L8.30762 23.2H9.65304L14.8865 17.5462L19.1149 23.2H23.6931L17.4186 14.8109L22.9826 8.79999H21.6372L16.8175 14.0069L12.9233 8.79999H8.34505ZM10.3236 9.79092H12.4268L21.7144 22.2091H19.6112L10.3236 9.79092Z"
        fill="#FAFAFA"
      />
    </svg>
  );
};

// INSTAGRAM ICON
export const InstaIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
    >
      <g clipPath="url(#clip0_303_1567)">
        <path
          d="M26.2541 -2.03125H5.85656C1.26833 -2.03125 -2.45117 1.68825 -2.45117 6.27649V26.674C-2.45117 31.2623 1.26833 34.9818 5.85656 34.9818H26.2541C30.8423 34.9818 34.5618 31.2623 34.5618 26.674V6.27649C34.5618 1.68825 30.8423 -2.03125 26.2541 -2.03125Z"
          fill="url(#paint0_linear_303_1567)"
        />
        <path
          d="M10.3693 4.37891H21.9079C22.1643 4.50711 22.5489 4.50711 22.8053 4.63532C23.9305 4.81767 24.9825 5.31022 25.8431 6.05761C26.7038 6.80499 27.3389 7.7776 27.6771 8.86611C27.8665 9.49338 27.9953 10.1374 28.0617 10.7892V22.0713C27.8785 23.5012 27.3505 24.8651 26.5233 26.0457C25.8136 26.8679 24.9239 27.5154 23.9233 27.9379C22.9227 28.3604 21.8382 28.5464 20.754 28.4816H11.1386C9.42261 28.5649 7.73542 28.0177 6.39497 26.9431C5.57984 26.2389 4.93657 25.3575 4.51438 24.3664C4.09218 23.3754 3.90223 22.3009 3.95906 21.2251V12.2507C3.93788 11.607 3.98082 10.9628 4.08726 10.3277C4.21672 9.01327 4.75715 7.77313 5.63174 6.78346C6.50634 5.79379 7.6706 5.10494 8.95908 4.81481L10.3693 4.37891ZM6.39497 16.5585V21.5585C6.3403 22.1952 6.42548 22.8362 6.64454 23.4365C6.8636 24.0369 7.21124 24.5821 7.66313 25.0339C8.11501 25.4858 8.66021 25.8335 9.26055 26.0525C9.86089 26.2716 10.5019 26.3568 11.1386 26.3021C14.4719 26.4303 17.8053 26.4303 21.1386 26.3021C24.0874 26.3021 25.754 24.5072 25.8822 21.5585C26.0105 18.2251 26.0105 14.8918 25.8822 11.5584C25.9155 10.9267 25.8155 10.2951 25.5889 9.70456C25.3622 9.11399 25.014 8.57766 24.5667 8.13037C24.1194 7.68308 23.5831 7.33482 22.9925 7.10818C22.4019 6.88155 21.7703 6.7816 21.1386 6.81482C17.8053 6.68661 14.4719 6.68661 11.1386 6.81482C10.5019 6.76015 9.86089 6.84533 9.26055 7.06439C8.66021 7.28345 8.11501 7.63109 7.66313 8.08298C7.21124 8.53486 6.8636 9.08006 6.64454 9.6804C6.42548 10.2807 6.3403 10.9217 6.39497 11.5584V16.5585Z"
          fill="white"
        />
        <path
          d="M9.9082 16.6102C9.91159 14.9451 10.5745 13.3492 11.7519 12.1718C12.9293 10.9945 14.5252 10.3315 16.1903 10.3281C17.8461 10.3609 19.425 11.0333 20.5961 12.2044C21.7672 13.3755 22.4396 14.9544 22.4724 16.6102C22.469 18.2753 21.806 19.8712 20.6286 21.0486C19.4513 22.226 17.8554 22.8889 16.1903 22.8923C14.5344 22.8595 12.9556 22.1871 11.7845 21.016C10.6134 19.8449 9.941 18.266 9.9082 16.6102ZM16.1903 12.6358C15.4116 12.6232 14.6469 12.8433 13.9941 13.2681C13.3413 13.6928 12.8302 14.3028 12.5264 15.0199C12.2225 15.7369 12.1397 16.5284 12.2885 17.2928C12.4373 18.0573 12.811 18.7599 13.3617 19.3106C13.9124 19.8613 14.615 20.235 15.3794 20.3838C16.1439 20.5326 16.9354 20.4498 17.6524 20.1459C18.3695 19.8421 18.9795 19.331 19.4042 18.6782C19.829 18.0254 20.0491 17.2607 20.0365 16.482C20.0365 15.4619 19.6312 14.4836 18.9099 13.7623C18.1886 13.0411 17.2104 12.6358 16.1903 12.6358Z"
          fill="white"
        />
        <path
          d="M21.0615 10.0706C21.0543 9.86667 21.0892 9.66342 21.164 9.47352C21.2388 9.28362 21.3518 9.11115 21.4961 8.96684C21.6404 8.82252 21.8129 8.70946 22.0028 8.63468C22.1927 8.5599 22.396 8.525 22.5999 8.53217C22.9991 8.55916 23.3749 8.72992 23.6578 9.0128C23.9406 9.29568 24.1114 9.6715 24.1384 10.0706C24.1384 10.4787 23.9763 10.87 23.6878 11.1585C23.3993 11.447 23.008 11.6091 22.5999 11.6091C22.1919 11.6091 21.8006 11.447 21.5121 11.1585C21.2236 10.87 21.0615 10.4787 21.0615 10.0706Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_303_1567"
          x1="-4.81016"
          y1="37.0331"
          x2="38.7798"
          y2="-5.91589"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FED576" />
          <stop offset="0.26" stopColor="#F47133" />
          <stop offset="0.61" stopColor="#BC3081" />
          <stop offset="1" stopColor="#4C63D2" />
        </linearGradient>
        <clipPath id="clip0_303_1567">
          <rect
            x="0.0546875"
            y="0.474609"
            width="32"
            height="32"
            rx="5"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// WHITE WHATSAPP ICON
export const WhiteWhatsAppIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="5" fill="#0E202B" />
      <path
        d="M23 8.91006C22.0832 7.98399 20.9912 7.24973 19.7876 6.75011C18.5841 6.25049 17.2931 5.99552 15.99 6.00006C10.53 6.00006 6.08 10.4501 6.08 15.9101C6.08 17.6601 6.54 19.3601 7.4 20.8601L6 26.0001L11.25 24.6201C12.7 25.4101 14.33 25.8301 15.99 25.8301C21.45 25.8301 25.9 21.3801 25.9 15.9201C25.9 13.2701 24.87 10.7801 23 8.91006ZM15.99 24.1501C14.51 24.1501 13.06 23.7501 11.79 23.0001L11.49 22.8201L8.37 23.6401L9.2 20.6001L9 20.2901C8.17775 18.977 7.74114 17.4593 7.74 15.9101C7.74 11.3701 11.44 7.67006 15.98 7.67006C18.18 7.67006 20.25 8.53006 21.8 10.0901C22.5675 10.854 23.1757 11.7627 23.5894 12.7635C24.0031 13.7642 24.214 14.8372 24.21 15.9201C24.23 20.4601 20.53 24.1501 15.99 24.1501ZM20.51 17.9901C20.26 17.8701 19.04 17.2701 18.82 17.1801C18.59 17.1001 18.43 17.0601 18.26 17.3001C18.09 17.5501 17.62 18.1101 17.48 18.2701C17.34 18.4401 17.19 18.4601 16.94 18.3301C16.69 18.2101 15.89 17.9401 14.95 17.1001C14.21 16.4401 13.72 15.6301 13.57 15.3801C13.43 15.1301 13.55 15.0001 13.68 14.8701C13.79 14.7601 13.93 14.5801 14.05 14.4401C14.17 14.3001 14.22 14.1901 14.3 14.0301C14.38 13.8601 14.34 13.7201 14.28 13.6001C14.22 13.4801 13.72 12.2601 13.52 11.7601C13.32 11.2801 13.11 11.3401 12.96 11.3301H12.48C12.31 11.3301 12.05 11.3901 11.82 11.6401C11.6 11.8901 10.96 12.4901 10.96 13.7101C10.96 14.9301 11.85 16.1101 11.97 16.2701C12.09 16.4401 13.72 18.9401 16.2 20.0101C16.79 20.2701 17.25 20.4201 17.61 20.5301C18.2 20.7201 18.74 20.6901 19.17 20.6301C19.65 20.5601 20.64 20.0301 20.84 19.4501C21.05 18.8701 21.05 18.3801 20.98 18.2701C20.91 18.1601 20.76 18.1101 20.51 17.9901Z"
        fill="#FAFAFA"
      />
    </svg>
  );
};

// WHITE Insta ICON
export const WhiteInstaIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1081_710)">
        <path
          d="M26.1994 -2.50586H5.80188C1.21364 -2.50586 -2.50586 1.21364 -2.50586 5.80188V26.1994C-2.50586 30.7877 1.21364 34.5072 5.80188 34.5072H26.1994C30.7877 34.5072 34.5072 30.7877 34.5072 26.1994V5.80188C34.5072 1.21364 30.7877 -2.50586 26.1994 -2.50586Z"
          fill="#FAFAFA00"
        />
        <path
          d="M11.4049 6.23676H20.7115C20.9183 6.34016 21.2285 6.34016 21.4353 6.44357C22.3429 6.59065 23.1914 6.98792 23.8856 7.59075C24.5797 8.19357 25.092 8.97804 25.3648 9.856C25.5175 10.3619 25.6214 10.8814 25.675 11.4071V20.5069C25.5272 21.6602 25.1014 22.7603 24.4341 23.7126C23.8618 24.3757 23.1441 24.898 22.3371 25.2387C21.5301 25.5795 20.6553 25.7296 19.7808 25.6773H12.0253C10.6412 25.7445 9.2804 25.3031 8.19923 24.4364C7.54177 23.8684 7.02293 23.1575 6.6824 22.3581C6.34187 21.5588 6.18866 20.6921 6.2345 19.8244V12.586C6.21741 12.0668 6.25205 11.5472 6.3379 11.0348C6.44232 9.9747 6.87822 8.97444 7.58364 8.1762C8.28906 7.37796 9.22812 6.82235 10.2674 6.58834L11.4049 6.23676ZM8.19923 16.0604V20.0933C8.15514 20.6069 8.22385 21.1239 8.40053 21.6081C8.57722 22.0923 8.85762 22.532 9.22209 22.8965C9.58657 23.261 10.0263 23.5414 10.5105 23.7181C10.9947 23.8948 11.5117 23.9635 12.0253 23.9194C14.7139 24.0228 17.4025 24.0228 20.091 23.9194C22.4694 23.9194 23.8137 22.4717 23.9171 20.0933C24.0205 17.4047 24.0205 14.7161 23.9171 12.0276C23.9439 11.518 23.8633 11.0086 23.6805 10.5323C23.4977 10.0559 23.2168 9.62335 22.856 9.26258C22.4953 8.90181 22.0627 8.62091 21.5863 8.43811C21.11 8.25531 20.6005 8.1747 20.091 8.20149C17.4025 8.09808 14.7139 8.09808 12.0253 8.20149C11.5117 8.1574 10.9947 8.2261 10.5105 8.40279C10.0263 8.57948 9.58657 8.85988 9.22209 9.22435C8.85762 9.58883 8.57722 10.0286 8.40053 10.5128C8.22385 10.997 8.15514 11.514 8.19923 12.0276V16.0604Z"
          fill="#FAFAFA"
        />
        <path
          d="M11.0332 16.1022C11.0359 14.7592 11.5707 13.472 12.5203 12.5223C13.4699 11.5727 14.7572 11.0379 16.1001 11.0352C17.4357 11.0617 18.7092 11.604 19.6537 12.5486C20.5983 13.4931 21.1406 14.7666 21.1671 16.1022C21.1644 17.4452 20.6296 18.7324 19.68 19.682C18.7304 20.6317 17.4431 21.1664 16.1001 21.1691C14.7646 21.1427 13.4911 20.6003 12.5466 19.6558C11.602 18.7112 11.0597 17.4377 11.0332 16.1022V16.1022ZM16.1001 12.8965C15.4721 12.8863 14.8553 13.0639 14.3288 13.4065C13.8022 13.7491 13.39 14.2411 13.1449 14.8194C12.8998 15.3978 12.833 16.0362 12.9531 16.6528C13.0731 17.2693 13.3745 17.836 13.8187 18.2802C14.2629 18.7244 14.8296 19.0258 15.4461 19.1458C16.0627 19.2659 16.7011 19.1991 17.2795 18.954C17.8578 18.7089 18.3498 18.2967 18.6924 17.7702C19.035 17.2436 19.2126 16.6268 19.2024 15.9988C19.2024 15.176 18.8755 14.3869 18.2937 13.8052C17.712 13.2234 16.9229 12.8965 16.1001 12.8965V12.8965Z"
          fill="#FAFAFA"
        />
        <path
          d="M20.0291 10.8276C20.0233 10.6631 20.0514 10.4991 20.1117 10.3459C20.1721 10.1928 20.2633 10.0537 20.3797 9.93727C20.4961 9.82087 20.6352 9.72968 20.7883 9.66936C20.9415 9.60904 21.1054 9.5809 21.2699 9.58668C21.5919 9.60845 21.895 9.74618 22.1232 9.97434C22.3513 10.2025 22.4891 10.5056 22.5108 10.8276C22.5108 11.1567 22.3801 11.4723 22.1474 11.705C21.9147 11.9377 21.599 12.0684 21.2699 12.0684C20.9408 12.0684 20.6252 11.9377 20.3925 11.705C20.1598 11.4723 20.0291 11.1567 20.0291 10.8276V10.8276Z"
          fill="#FAFAFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_1081_710">
          <rect width="32" height="32" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// LINKEDIN ICON
export const LinkedInIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
    >
      <g clipPath="url(#clip0_303_1575)">
        <path
          d="M30.2769 0.474609H1.83247C0.850626 0.474609 0.0546875 1.27055 0.0546875 2.25239V30.6968C0.0546875 31.6787 0.850626 32.4746 1.83247 32.4746H30.2769C31.2587 32.4746 32.0547 31.6787 32.0547 30.6968V2.25239C32.0547 1.27055 31.2587 0.474609 30.2769 0.474609Z"
          fill="#117EB8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.8937 12.8516H10.1706V26.6125H5.8937V12.8516ZM8.03281 6.01119C9.40036 6.01119 10.5115 7.1223 10.5115 8.48985C10.5115 9.85874 9.40036 10.9703 8.03281 10.9703C7.70324 10.9765 7.37573 10.917 7.06943 10.7952C6.76313 10.6734 6.48419 10.4918 6.24891 10.2609C6.01363 10.03 5.82674 9.75457 5.69916 9.45063C5.57157 9.14669 5.50586 8.82037 5.50586 8.49074C5.50586 8.16111 5.57157 7.83479 5.69916 7.53085C5.82674 7.22692 6.01363 6.95146 6.24891 6.7206C6.48419 6.48973 6.76313 6.30808 7.06943 6.18628C7.37573 6.06447 7.70324 6.00495 8.03281 6.01119ZM12.8533 12.8512H16.9555V14.7316H17.0124C17.5835 13.6499 18.9786 12.5094 21.059 12.5094C25.3897 12.5094 26.1897 15.3596 26.1897 19.065V26.6125H21.9155V19.9205C21.9155 18.325 21.8861 16.2721 19.6933 16.2721C17.4679 16.2721 17.1261 18.0103 17.1261 19.8054V26.6125H12.8528V12.8516L12.8533 12.8512Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_303_1575">
          <rect
            x="0.0546875"
            y="0.474609"
            width="32"
            height="32"
            rx="5"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WhiteLinkedInIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1081_718)">
        <rect width="32" height="32" rx="5" fill="#FAFAFA00" />
        <path
          d="M30.2222 0H1.77778C0.795938 0 0 0.795938 0 1.77778V30.2222C0 31.2041 0.795938 32 1.77778 32H30.2222C31.2041 32 32 31.2041 32 30.2222V1.77778C32 0.795938 31.2041 0 30.2222 0Z"
          fill="#FAFAFA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.36359 12.907H10.9854V24.5602H7.36359V12.907ZM9.17507 7.11421C10.3332 7.11421 11.2741 8.05514 11.2741 9.21324C11.2741 10.3725 10.3332 11.3138 9.17507 11.3138C8.89598 11.3191 8.61864 11.2687 8.35925 11.1655C8.09987 11.0623 7.86365 10.9085 7.6644 10.713C7.46516 10.5175 7.30689 10.2842 7.19885 10.0269C7.0908 9.76947 7.03516 9.49313 7.03516 9.21399C7.03516 8.93485 7.0908 8.65851 7.19885 8.40112C7.30689 8.14373 7.46516 7.91047 7.6644 7.71496C7.86365 7.51946 8.09987 7.36563 8.35925 7.26248C8.61864 7.15933 8.89598 7.10892 9.17507 7.11421ZM13.2572 12.9066H16.7311V14.499H16.7793C17.2629 13.5829 18.4444 12.6172 20.2062 12.6172C23.8736 12.6172 24.551 15.0308 24.551 18.1686V24.5602H20.9314V18.8932C20.9314 17.542 20.9066 15.8035 19.0496 15.8035C17.1651 15.8035 16.8757 17.2755 16.8757 18.7957V24.5602H13.2568V12.907L13.2572 12.9066Z"
          fill="#FAFAFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_1081_718">
          <rect width="32" height="32" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// ATHLETIFI LOGO
export const AthletifiLogo = ({ scale = 1 }: { scale?: number }) => {
  // Use a random number for the gradient because otherwise including it
  // multiple times in the page breaks things (because gradients are global?!?)
  const salt = Math.floor(Math.random() * 256 * 8)
    .toString(16)
    .padStart(8, '0');
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={75 * scale}
      height={64 * scale}
      viewBox="0 0 75 64"
      fill="none"
    >
      <defs>
        <linearGradient
          id={`g-${salt}`}
          x1="25.99"
          x2="51.39"
          y1="59.99"
          y2="15.98"
          gradientTransform="matrix(1 0 0 -1 0 66)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#11568c"></stop>
          <stop offset="1" stopColor="#00c5f4"></stop>
        </linearGradient>
      </defs>
      <path
        fill={`url(#g-${salt})`}
        strokeWidth="0"
        d="M63.31 19.49c-.3-.89-.74-1.69-1.44-2.28-.84-.79-1.89-1.24-3.08-1.34-.5-.05-.99 0-1.44.1h-.1l-8.94-6.01-3.57-2.38-2.09-1.44s-.05-.05-.05-.1c.05-.74 0-1.44-.15-2.04-.3-.99-.79-1.84-1.54-2.48-.25-.2-.5-.4-.79-.6-.74-.45-1.54-.7-2.38-.74-.74-.05-1.44.1-2.13.35-1.14.45-2.04 1.19-2.68 2.28-.15.3-.3.6-.4.89-.25.79-.35 1.59-.25 2.43v.05l-14.55 9.78h-.05c-1.39-.35-2.73-.2-3.97.5-.65.35-1.19.84-1.64 1.44-.74 1.04-1.09 2.23-.94 3.57.05.7.25 1.29.6 1.89.55.99 1.34 1.79 2.33 2.28.3.15.55.25.84.35 0 0 .05 0 .05.05l1.84 4.22 4.57 10.63s.05.05.05.1v.05c-.79.7-1.34 1.59-1.64 2.63-.3 1.19-.2 2.38.3 3.53.35.7.79 1.29 1.39 1.79.84.7 1.79 1.09 2.88 1.19.7.05 1.39 0 2.09-.25a4.936 4.936 0 002.68-2.04c0-.05.05-.05.1-.05h5.21c3.67 0 7.35 0 11.02-.05h.05c.55.84 1.24 1.44 2.13 1.89.79.4 1.64.55 2.48.5.94-.05 1.84-.35 2.63-.89.25-.2.55-.4.74-.65.79-.79 1.29-1.74 1.44-2.83.1-.65.1-1.29-.05-1.94-.25-1.09-.79-2.04-1.64-2.78v-.05l.74-1.69 5.56-12.81.2-.4s0-.05.05-.05c1.04-.3 1.89-.84 2.58-1.64.74-.84 1.14-1.84 1.24-2.98 0-.7-.1-1.34-.3-1.99zM42.06 7.82s.05 0 0 0l1.09.7 3.33 2.23c2.93 1.99 5.91 3.97 8.84 5.96l.05.05s.01.06-.05.1c-1.14.84-1.84 1.99-2.09 3.43-.05.35-.05.7-.05 1.04l.05.5v.05l-8.79 3.03h-.05c-.1-.35-.25-.7-.4-.99-.3-.6-.7-1.14-1.14-1.64-1.19-1.29-2.68-2.04-4.42-2.28-.05 0-.05-.05-.05-.05v-4.27l.05-5.11c.94-.15 1.74-.55 2.43-1.14.5-.5.89-.99 1.19-1.59zM30.09 36.41zm0 0zm0 0zm0 0zm-9.78-18.72c-.25-.3-.5-.55-.84-.79v-.05l13.41-8.99c.84 1.44 2.09 2.33 3.67 2.63.03 0 .05.01.05.05v9.38s0 .05-.05.05c-1.09.15-2.09.5-2.98 1.09-1.49.94-2.48 2.28-3.03 4.02h-.05l-1.94-.65-6.11-2.18-.99-.35s-.05 0-.05-.05c.15-.79.05-1.59-.15-2.33-.15-.7-.5-1.29-.94-1.84zm5.96 7.7zm0 0zm0 0zm0 0zm-3.87-3.13zm0 0zm-4.02 7.35l-1.44-3.38s0-.05.05-.05c.3-.05.6-.1.89-.2 1.34-.45 2.33-1.24 3.03-2.48h.05l5.41 1.94 3.87 1.39.05.05v.05c-.05.84.1 1.69.35 2.53.4 1.14 1.04 2.13 1.89 2.98l.4.35v.05l-2.88 3.48-3.13 3.82s-.05.05-.1 0c-1.29-.5-2.53-.55-3.87-.05 0 0-.05 0-.05-.05-1.49-3.48-2.98-6.95-4.52-10.43zm26.31 16.38c-3.08 0-5.16.05-6.31.05h-8.49v-.05c.2-.99.15-1.94-.2-2.88a5.66 5.66 0 00-1.34-2.04v-.05l1.19-1.44 3.53-4.27 1.29-1.54s.05-.05.1 0c.4.2.84.35 1.29.45 1.49.4 2.98.3 4.42-.25h.05l4.32 5.26 1.64 1.99v.05c-.5.5-.89 1.09-1.14 1.74-.45.94-.55 1.94-.35 2.98zm.35-3.03zm0 0zm0 0zm0 0zm6.7-2.88h-.1c-1.34-.5-2.68-.45-4.02.15h-.05l-1.29-1.59-4.57-5.51v-.05c.79-.6 1.44-1.29 1.94-2.09.6-.99.94-2.04 1.04-3.18.05-.4.05-.79 0-1.14 0 0 0-.05.05-.05l8.99-3.23c.84 1.54 2.18 2.48 3.97 2.78s.05.05 0 .05l-.5 1.14c-1.79 4.22-3.62 8.44-5.46 12.71z"
      ></path>
      <path
        fill="#637177"
        strokeWidth="0"
        d="M4.83 61.29h-.35s-.15.2-.25.35c-.4.65-.79 1.29-1.19 1.99l-.05.05H.26c2.38-3.72 4.77-7.4 7.15-11.07l.05-.05s.1-.1.2-.1h2.38c.1.25.15.55.25.94.84 3.43 1.69 6.8 2.53 10.23v.05h-2.53s-.05 0-.05-.05l-.5-2.33-.05-.05c-1.64.05-3.28.05-4.87.05zm.99-1.94H9.2l.05-.05c-.3-1.34-.55-2.58-.84-3.82 0-.1-.05-.2-.1-.35 0-.03-.01-.03-.05 0L5.73 59.3s0 .05.1.05zM65.39 54.54s0 .05 0 0l-.6 2.93s0 .05.05.05h5.11s.05 0 .05.05l-.4 1.94s-.05.1-.1.1h-5.01s-.1.05-.1.1l-.79 3.97-.05.05h-2.53c.05-.3.1-.55.15-.84.7-3.43 1.39-6.85 2.09-10.33 0 0 0-.05.05-.05h8.39s.05 0 .05.05l-.4 1.99-.05.05h-5.66c-.15-.05-.2-.05-.25-.05zM16.94 56.18h-2.88l-.05-.05.35-1.69s0-.05.05-.05h7.94l.05.05-.35 1.64-.05.05h-2.93c-.1.4-.2.79-.25 1.24-.4 2.09-.84 4.17-1.24 6.26 0 .05-.05.05-.05.05h-2.04s-.05 0-.05-.05c.15-.79.3-1.59.45-2.33.4-1.64.74-3.38 1.04-5.11 0 .05 0 0 0 0zM24.64 59.95l-.74 3.72s-.05.1-.1.1h-1.99s-.05-.01-.05-.05l1.84-9.19s0-.05.05-.05h2.09s.05 0 .05.05l-.7 3.57s0 .05.05.05h4.02c.1 0 .2-.05.2-.15v-.1c.2-1.14.45-2.28.7-3.38 0-.05.05-.05.05-.05h1.94s.05.01.05.05l-1.84 9.14s-.05.1-.1.1h-2.04s-.05 0-.05-.05l.74-3.72s0-.05-.05-.05h-4.12zM32.73 63.73h-.2s-.05-.01-.05-.05l1.84-9.19.05-.05h2.04s.05.01.05.05l-1.49 7.4s.01.06.05.1h4.52s.05 0 .05.05l-.35 1.69s-.05.05-.1.05c-2.13-.05-4.27-.05-6.4-.05zM43.75 58.22h4.17s.05.01.05.05l-.3 1.54s0 .05-.05.05H43.4s-.05 0-.05.05c-.05.1-.05.2-.1.3-.1.6-.25 1.19-.35 1.79v.05h4.97s.05 0 .05.05l-.35 1.64h-7.15s-.1-.05-.05-.1v-.05c.6-3.03 1.24-6.06 1.84-9.14 0 0 0-.05.05-.05h6.95s.05 0 .05.05l-.35 1.64-.05.05h-4.82c-.1.7-.25 1.39-.3 2.09-.05-.05 0 0 0 0zM54.97 56.18s-.05.01-.05.05l-1.49 7.45-.05.05h-2.04s-.05 0-.05-.05l1.49-7.4s-.01-.05-.05-.05H49.9s-.05 0-.05-.05l.35-1.69s0-.05.05-.05h7.99l-.35 1.69h-.05l-2.88.05zM57.6 63.73l-.05-.05 1.84-9.19s0-.05.05-.05h2.04s.05 0 .05.05l-1.84 9.19-.05.05H57.6zM70.76 63.73s0-.02 0 0l1.84-9.23h2.09s.05.01.05.05c-.05.25-.1.5-.15.79-.55 2.78-1.14 5.61-1.69 8.39 0 .05-.05.1-.1.1l-2.04-.1z"
      ></path>
    </svg>
  );
};

// PLEYR LOGO
export const PleyrLogo = ({
  scale = 1,
  mode,
  className,
}: {
  scale?: number;
  /** 'responsive' makes SVG width:100% and height:auto so wrappers control size. Use 'fixed' to keep pixel sizing. */
  mode?: 'responsive' | 'fixed';
  className?: string;
}) => {
  const fixedWidth = 620 * scale;
  const fixedHeight = 202 * scale;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2258 737"
      preserveAspectRatio="xMidYMid meet"
      // In responsive mode, width is 100% and height auto so parent can constrain size.
      width={
        mode === 'fixed'
          ? fixedWidth
          : mode === 'responsive'
            ? '100%'
            : undefined
      }
      height={mode === 'fixed' ? fixedHeight : undefined}
      style={
        mode === 'responsive' ? { height: 'auto', display: 'block' } : undefined
      }
      className={className}
      role="img"
      aria-label="Pleyr"
    >
      <path
        fill="#f9f9f9"
        d="M221.8,39.5C278.6,6.8,346.7-6.9,416.2,5.4c157.3,27.7,262.6,178.1,234.8,335.4-27.7,157.3-178.1,262.6-335.4,234.8-44.6-7.9-85-25.6-119.4-50.5,133.1-54,266.2-108,399.3-162,23.2-9.4,26.9-41,6.4-55.5-126.7-89.4-253.4-178.7-380.1-268.1Z"
      />
      <path
        fill="#f9f9f9"
        d="M188.7,61.6c-55,42.5-94.9,104.8-107.9,178.6C54.2,391.2,27.6,542.1,1,693.1c14.7,2.6,29.4,5.2,44.1,7.8,59.4,10.5,117.3-35.3,129.1-102.2,4.1-23.2,41.3-234.4,78.6-445.5-21.3-30.5-42.6-60.9-64-91.4h0Z"
      />
      <path
        fill="none"
        stroke="#231f20"
        strokeMiterlimit={10}
        strokeWidth={0}
        d="M539.9,141.8c6.8-32.1-13.7-63.6-45.6-70.3-32-6.7-63.3,13.8-70.1,45.9-6.8,32.1,13.7,63.6,45.6,70.3,32,6.7,63.3-13.8,70.1-45.9Z"
      />
      <path
        fill="#f9f9f9"
        d="M745.4.8c-27.5,161.5-55.1,322.9-82.1,484.4,0,33,11.2,58.7,33.7,77.2,22.5,18.5,53.5,27.7,93,27.7s56.5-1.8,79.2-5.2c17.9-2.8,45.6-9.2,69.6-17.6-20.9-27-45.7-66-56.3-97.2h-18.1c-18.4,0-28.8-20.8-28.8-46.4,14.8-78.4,33.2-189.7,52.3-307.4,8.1-49.7-29.5-97.3-84.1-107.1-28.2-5.1-49.8-8.4-58.3-8.4h0Z"
      />
      <path
        fill="#f9f9f9"
        d="M1351.3,520.6c-66.1,48.3-140.6,69.9-210.4,69.9s-84.2-7.8-118.6-23.4c-34.4-15.6-61-37.7-79.8-66.3-18.8-28.6-28.2-62.2-28.2-100.9s10.7-85.7,32-121.6c21.3-35.9,51.3-64,90-84.4,38.7-20.3,83.1-30.5,133.3-30.5s80.6,7.7,112.2,23c31.6,15.3,55.7,36.7,72.3,64,16.6,27.4,24.9,58.9,24.9,94.5s-3,46.4-9,71.5h-288.5c3.5,17.1,11.8,29.4,24.9,36.9,13,7.5,31.1,11.3,54.2,11.3,34.1,0,64-9.5,89.6-28.6,16.9,14.1,67.5,56.3,101.2,84.5h0ZM1162,279.5c-18.6,0-34,4.9-46.3,14.7-12.3,9.8-21.5,23.2-27.5,40.3h134.8c0-17.1-5.5-30.5-16.6-40.3-11-9.8-25.9-14.7-44.4-14.7h0Z"
      />
      <path
        fill="#f9f9f9"
        d="M1719.4,225.8c-12.5,62-22.8,112.8-22.8,112.8-5.4,26.6-14.4,46.4-27.1,59.2-12.7,12.8-28.5,19.2-47.5,19.1-13.6,0-23.9-3.7-30.9-11.1-7-7.4-10.5-18.2-10.5-32.6,0-3.8.3-7.9.9-12.2.6-4.4,1.3-8.8,2.1-13.4,0,0,11-55,24.3-121.7,6.2-30.8-9.7-55.3-27.1-55.3h-132.1c-19.6,98.6-39.2,197.3-39.2,197.3-3.6,18.8-5.4,36.1-5.3,52,.7,46.7,14.3,81.7,40.9,105.1,26.5,23.3,61.6,35,105.3,35,18.2,0,36.7-3,55.5-9.2,18.7-6.2,36.6-15.7,53.8-28.4l-1.5,7.5c-4.4,25.5-14.3,45.2-29.7,59.1-15.4,13.9-39.4,20.9-72,21.1-25.3-.1-49.8-3.8-73.6-11.1-23.8-7.2-44.2-17.2-61.2-29.9,0,0-62.4,54.9-131.1,81.8,92.7,52.4,186.4,85.5,262.9,85.7,74.6.6,135.9-17.8,184.1-55.3,48.1-37.5,80.7-98,97.7-181.6,0,0,32.8-164.6,65.5-329.1h-132.1c-23.9,0-43.2,24.8-49.3,55.2h0Z"
      />
      <path
        fill="#f9f9f9"
        d="M2098.4,213.1s4.1-21.2,8.3-42.4h-160.4c-27.4,137.4-54.7,274.9-82.1,412.3h170.2l38.4-190.7c6-28.8,17.7-49.6,34.9-62.5,17.2-12.9,39.3-19.5,58.8-21.1s38.4,3.2,57.9,11.2c15.1-78.2,32.7-156.4,32.7-156.4-29.5,0-70.6,3.9-95.1,11.9s-45.7,20.6-63.6,37.9h0Z"
      />
      <path
        style={{ isolation: 'isolate', opacity: 0.5 }}
        d="M537.9,153.5c6.8-32.1-13.7-63.6-45.6-70.3-32-6.7-63.3,13.8-70.1,45.9-6.8,32.1,13.7,63.6,45.6,70.3,32,6.7,63.3-13.8,70.1-45.9Z"
      />
      <path
        style={{ isolation: 'isolate', opacity: 0.5 }}
        d="M191.7,499.2c42.4-44,84.7-88,127.1-132,24.7-25.7,27.8-65.3,7.4-94.5-52.5-75-104.9-149.9-157.4-224.9-8.7-12.4,6.7-27.8,19.1-19,137.3,96.9,274.6,193.7,412,290.6,20.5,14.5,16.9,46.1-6.4,55.5-136.4,55.3-272.8,110.7-409.1,166,2.4-13.9,4.9-27.7,7.3-41.6Z"
      />
      <path
        fill="#10bbe6"
        d="M539.9,141.8c6.8-32.1-13.7-63.6-45.6-70.3-32-6.7-63.3,13.8-70.1,45.9-6.8,32.1,13.7,63.6,45.6,70.3,32,6.7,63.3-13.8,70.1-45.9Z"
      />
      <path
        fill="#10bbe6"
        d="M193.7,487.5c42.4-44,84.7-88,127.1-132,24.7-25.7,27.8-65.3,7.4-94.5-52.5-75-104.9-149.9-157.4-224.9-8.7-12.4,6.7-27.8,19.1-19,137.3,96.8,274.6,193.7,412,290.5,20.5,14.5,16.9,46.1-6.4,55.5-136.4,55.3-272.8,110.7-409.1,166,2.4-13.9,4.9-27.7,7.3-41.6Z"
      />
    </svg>
  );
};

// BLUE UNDERLINE
export const UnderLineText = () => {
  return (
    <svg
      className="sm:w-[209px]"
      width="150"
      height="10"
      viewBox="0 0 211 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.948693 3.57332C3.5877 -3.8515 161.353 5.45592 204.446 3.57332C214.185 3.14787 209.771 6.6513 204.446 6.6513C171.916 7.92592 90.8918 10.1851 27.0385 9.02472C6.9624 8.37921 -1.69031 10.9981 0.948693 3.57332Z"
        fill="#00C5F4"
      />
    </svg>
  );
};

// BLUE SHADOW BACKGROUND
export const BlueShadow = () => {
  return (
    <svg
      width="579"
      height="739"
      viewBox="0 0 579 739"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.25" filter="url(#filter0_f_303_1617)">
        <circle
          cx="178.5"
          cy="400.5"
          r="178.5"
          fill="url(#paint0_linear_303_1617)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_303_1617"
          x="-222"
          y="0"
          width="801"
          height="801"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="111"
            result="effect1_foregroundBlur_303_1617"
          />
        </filter>
        <linearGradient
          id="paint0_linear_303_1617"
          x1="101.364"
          y1="263.6"
          x2="287.19"
          y2="570.26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#11568C" />
          <stop offset="1" stopColor="#00C5F4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

// BLUE SHADOW CENTER
export const CenterBlueShadow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="400"
      height="400"
      viewBox="0 0 567 567"
      fill="none"
    >
      <g opacity="0.2" filter="url(#filter0_f_300_558)">
        <circle
          cx="100.002"
          cy="100.002"
          r="100.002"
          transform="matrix(-0.773423 -0.63389 -0.63389 0.773423 424.469 269.781)"
          fill="url(#paint0_linear_300_558)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_300_558"
          x="0.729492"
          y="0.729248"
          width="566.01"
          height="566.01"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="91.5"
            result="effect1_foregroundBlur_300_558"
          />
        </filter>
        <linearGradient
          id="paint0_linear_300_558"
          x1="56.7878"
          y1="23.3061"
          x2="160.894"
          y2="195.108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#11568C" />
          <stop offset="1" stopColor="#00C5F4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

// BUTTON ARROW BLACK
export const ArrowButton = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_453_36)">
        <path
          d="M6.96967 17.9443C6.67678 18.2372 6.67678 18.712 6.96967 19.0049C7.26257 19.2978 7.73744 19.2978 8.03033 19.0049L6.96967 17.9443ZM19.25 7.47461C19.25 7.06039 18.9142 6.72461 18.5 6.72461L11.75 6.72461C11.3358 6.72461 11 7.0604 11 7.47461C11 7.88882 11.3358 8.22461 11.75 8.22461L17.75 8.22461L17.75 14.2246C17.75 14.6388 18.0858 14.9746 18.5 14.9746C18.9142 14.9746 19.25 14.6388 19.25 14.2246L19.25 7.47461ZM8.03033 19.0049L19.0303 8.00494L17.9697 6.94428L6.96967 17.9443L8.03033 19.0049Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_453_36">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 -1 24.5 24.4746)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// WHITE ARROW BUTTON
export const ButtonWhiteArrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_638_297)">
        <path
          d="M6.46967 17.4697C6.17678 17.7626 6.17678 18.2374 6.46967 18.5303C6.76257 18.8232 7.23744 18.8232 7.53033 18.5303L6.46967 17.4697ZM18.75 7C18.75 6.58579 18.4142 6.25 18 6.25L11.25 6.25C10.8358 6.25 10.5 6.58579 10.5 7C10.5 7.41422 10.8358 7.75 11.25 7.75L17.25 7.75L17.25 13.75C17.25 14.1642 17.5858 14.5 18 14.5C18.4142 14.5 18.75 14.1642 18.75 13.75L18.75 7ZM7.53033 18.5303L18.5303 7.53033L17.4697 6.46967L6.46967 17.4697L7.53033 18.5303Z"
          fill="#FDFEFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_638_297">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 -1 24 24)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// CROSS OR CANCEL ICON
export const CancelIcon = () => {
  return (
    <svg
      className="sm:w-[36px] w-6"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4136 18L33.8939 7.5197C35.3889 6.0247 35.3889 3.60087 33.8939 2.10587C32.3988 0.610869 29.9752 0.610869 28.4801 2.10587L17.9998 12.5862L7.51945 2.10587C6.02445 0.610869 3.60062 0.610869 2.10562 2.10587C0.610625 3.60087 0.610625 6.0247 2.10562 7.5197L12.5859 18L2.10562 28.4803C0.610625 29.9753 0.610625 32.3992 2.10562 33.8942C2.85312 34.6416 3.83281 35.0154 4.8125 35.0154C5.79219 35.0154 6.77195 34.6417 7.51937 33.8942L17.9998 23.4138L28.4801 33.8942C29.2276 34.6416 30.2073 35.0154 31.187 35.0154C32.1666 35.0154 33.1463 34.6417 33.8938 33.8942C35.3888 32.3992 35.3888 29.9753 33.8938 28.4803L23.4136 18Z"
        fill="white"
      />
    </svg>
  );
};

export const PaginationArrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.16506 19.503L10.5271 2.993C11.1171 1.669 12.8821 1.669 13.4731 2.993L20.8351 19.503C21.5021 20.998 20.0211 22.55 18.6331 21.809L12.7291 18.657C12.2701 18.412 11.7291 18.412 11.2711 18.657L5.36706 21.809C3.97906 22.549 2.49706 20.999 3.16506 19.503Z"
        fill="#00C5F4"
      />
    </svg>
  );
};

// Trusted Partners
// EYEBALL ICON
export const EyeBallIcon = () => {
  return (
    <svg
      className="lg:max-w-[332px] md:max-w-[250px] max-w-[170px]"
      width="332"
      height="72"
      viewBox="0 0 332 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.2299 38.1107L33.3034 46.1589C32.9089 46.3956 32.5144 46.4745 32.0804 46.4745C31.6465 46.4745 31.2519 46.3562 30.8574 46.1589C30.1078 45.7249 29.6344 44.8965 29.6344 44.0285V27.9716C29.6344 27.1037 30.1078 26.2752 30.8574 25.8412C31.607 25.4072 32.5539 25.4072 33.3034 25.8412L47.2299 33.8894C47.9795 34.3234 48.4529 35.1518 48.4529 36.0198C48.4529 36.8877 47.9795 37.6768 47.2299 38.1107ZM36.6963 12.0725C23.4799 12.0725 12.749 22.8034 12.749 36.0198C12.749 49.2362 23.4799 59.9276 36.6963 59.9276C49.9127 59.9276 60.6436 49.1967 60.6436 35.9803C60.6436 22.764 49.9127 12.0725 36.6963 12.0725Z"
        fill="#00C5FF"
      />
      <path
        d="M1.70245 32.5873C2.17588 32.824 2.76765 32.7057 3.12272 32.3111C8.48817 26.2356 19.9687 16.057 36.7357 16.057C53.5027 16.057 64.9438 26.3145 70.2698 32.4295C70.5065 32.7057 70.8615 32.8635 71.1772 32.8635H71.2166C71.8873 32.8635 72.4396 32.3111 72.4396 31.6405C72.4396 31.4827 72.4002 31.3249 72.3607 31.2065C69.9936 13.4137 54.7257 0.0395381 36.6568 8.62934e-05C18.6667 -0.0393656 3.31998 13.4532 0.992322 31.3249C0.913418 31.8772 1.18958 32.3901 1.70245 32.5873Z"
        fill="#49545C"
      />
      <path
        d="M71.6898 39.3733C71.2164 39.1366 70.6246 39.255 70.2695 39.689C64.9041 45.7645 53.3841 55.9431 36.6565 55.9431C19.9289 55.9431 8.44846 45.6856 3.12246 39.5311C2.7674 39.1366 2.17562 39.0183 1.7022 39.2155C1.22878 39.4522 0.91316 39.9651 0.992064 40.478C3.24082 58.4286 18.5481 71.9606 36.6565 72H36.7354C54.7649 72 70.1117 58.5075 72.4394 40.5963C72.4788 40.1229 72.1632 39.6101 71.6898 39.3733Z"
        fill="#49545C"
      />
      <path
        d="M90.2319 17.9902H117.454V25.0127H98.1223V32.3507H115.126V39.4126H98.1223V46.9873H117.69V54.0098H90.2319V17.9902Z"
        fill="#49545C"
      />
      <path
        d="M134.892 39.8071L121.044 17.9902H130.315L138.916 32.4296L147.674 17.9902H156.669L142.821 39.6493V54.0098H134.892V39.8071Z"
        fill="#49545C"
      />
      <path
        d="M161.64 17.9902H188.822V25.0127H169.491V32.3507H186.495V39.4126H169.491V46.9873H189.059V54.0098H161.64V17.9902Z"
        fill="#49545C"
      />
      <path
        d="M213.046 39.1364H203.893V47.0662H213.322C216.833 47.0662 218.924 45.8432 218.924 43.1605V43.0422C218.885 40.6356 217.109 39.1364 213.046 39.1364ZM216.873 28.6422C216.873 26.2751 215.019 24.9338 211.665 24.9338H203.854V32.548H211.152C214.663 32.548 216.873 31.4039 216.873 28.7211V28.6422ZM196.121 17.9902H212.849C216.952 17.9902 220.226 19.1343 222.278 21.1858C223.935 22.8428 224.763 24.8549 224.763 27.3009V27.4192C224.763 31.4828 222.593 33.771 220.029 35.1912C224.211 36.7693 226.775 39.2153 226.775 44.0679V44.1863C226.775 50.7747 221.41 54.0887 213.283 54.0887H196.121V17.9902Z"
        fill="#49545C"
      />
      <path
        d="M273.999 17.9902H281.928V46.8295H299.918V54.0098H273.999V17.9902Z"
        fill="#49545C"
      />
      <path
        d="M305.876 17.9902V54.0098H331.796V46.8295H313.806V17.9902H305.876Z"
        fill="#49545C"
      />
      <path
        d="M244.449 38.9392L249.223 27.2614L253.997 38.9392H244.449ZM253.089 17.9902H245.554L230.247 54.0098H238.334L241.648 45.9221H256.877L260.151 54.0098H268.436L253.089 17.9902Z"
        fill="#49545C"
      />
    </svg>
  );
};

// VILLANOVA ICON
export const VillanovaIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="max-w-[100px] md:max-w-[130px]"
      width="130"
      height="130"
      fill="none"
      viewBox="0 0 130 130"
    >
      <defs>
        <linearGradient
          id="c"
          x1="65.13"
          x2="65.13"
          y1="340.45"
          y2="319.92"
          gradientTransform="matrix(1 0 0 -1 0 424.6)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0"></stop>
          <stop offset="0.09" stopColor="#13171a"></stop>
          <stop offset="0.33" stopColor="#414f58"></stop>
          <stop offset="0.55" stopColor="#667b89"></stop>
          <stop offset="0.74" stopColor="#809bad"></stop>
          <stop offset="0.9" stopColor="#91aec3"></stop>
          <stop offset="1" stopColor="#97b6cb"></stop>
        </linearGradient>
        <linearGradient
          id="d"
          x1="76.37"
          x2="76.37"
          y1="340.45"
          y2="319.92"
          gradientTransform="matrix(1 0 0 -1 0 424.6)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0"></stop>
          <stop offset="0.09" stopColor="#13171a"></stop>
          <stop offset="0.33" stopColor="#414f58"></stop>
          <stop offset="0.55" stopColor="#667b89"></stop>
          <stop offset="0.74" stopColor="#809bad"></stop>
          <stop offset="0.9" stopColor="#91aec3"></stop>
          <stop offset="1" stopColor="#97b6cb"></stop>
        </linearGradient>
        <linearGradient
          id="e"
          x1="87.59"
          x2="87.59"
          y1="338.15"
          y2="324.33"
          gradientTransform="matrix(1 0 0 -1 0 424.6)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0"></stop>
          <stop offset="0.09" stopColor="#13171a"></stop>
          <stop offset="0.33" stopColor="#414f58"></stop>
          <stop offset="0.55" stopColor="#667b89"></stop>
          <stop offset="0.74" stopColor="#809bad"></stop>
          <stop offset="0.9" stopColor="#91aec3"></stop>
          <stop offset="1" stopColor="#97b6cb"></stop>
        </linearGradient>
        <linearGradient
          id="f"
          x1="53.92"
          x2="53.92"
          y1="340.45"
          y2="319.92"
          gradientTransform="matrix(1 0 0 -1 0 424.6)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0"></stop>
          <stop offset="0.09" stopColor="#13171a"></stop>
          <stop offset="0.33" stopColor="#414f58"></stop>
          <stop offset="0.55" stopColor="#667b89"></stop>
          <stop offset="0.74" stopColor="#809bad"></stop>
          <stop offset="0.9" stopColor="#91aec3"></stop>
          <stop offset="1" stopColor="#97b6cb"></stop>
        </linearGradient>
        <linearGradient
          id="g"
          x1="42.68"
          x2="42.68"
          y1="338.15"
          y2="324.33"
          gradientTransform="matrix(1 0 0 -1 0 424.6)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0"></stop>
          <stop offset="0.09" stopColor="#13171a"></stop>
          <stop offset="0.33" stopColor="#414f58"></stop>
          <stop offset="0.55" stopColor="#667b89"></stop>
          <stop offset="0.74" stopColor="#809bad"></stop>
          <stop offset="0.9" stopColor="#91aec3"></stop>
          <stop offset="1" stopColor="#97b6cb"></stop>
        </linearGradient>
      </defs>
      <g strokeWidth="0">
        <path
          fill="#001f4e"
          d="M111.96 47.27V29.12l-1.61-1c-.77-.5-19.49-11.82-45.24-11.82S20.63 27.66 19.87 28.12l-1.61 1v18.15c-.04 1.27-.38 14.08 4.68 29.51 7.02 21.26 21.07 36.61 40.64 45.74l1.53.69 1.53-.69c19.57-9.1 33.65-24.48 40.64-45.74 5.1-15.43 4.72-28.24 4.68-29.51z"
        ></path>
        <path
          fill="#a0cced"
          d="M108.47 47.35V31S90.13 19.72 65.11 19.72 21.75 31 21.75 31v16.35s-2.38 50.88 43.36 72.14c45.7-21.26 43.36-72.14 43.36-72.14z"
        ></path>
        <path
          fill="#97b6cb"
          d="M109.47 47.31V30.46l-.46-.27c-.19-.12-18.84-11.44-43.9-11.44s-43.71 11.28-43.9 11.4l-.46.27v16.85c-.04.65-.42 13.55 4.57 28.74 3.03 9.13 7.37 16.65 12.93 23.64 6.95 8.79 15.85 15.7 26.44 20.61l.42.19.42-.19c10.59-4.91 19.46-11.86 26.44-20.61 5.56-7.02 9.9-14.54 12.93-23.64 4.99-15.16 4.6-28.05 4.57-28.7z"
        ></path>
        <path
          fill="#fff"
          d="M107.12 47.43V31.54l-2.8-1.34-1.11-.54c-6.79-3.26-20.8-8.71-38.14-8.71s-31.24 5.45-38.11 8.71l-1.11.54-2.8 1.34v15.85c0 .15-.5 13.24 4.64 28.51 6.22 18.5 17.65 31.66 33.96 40.41l.96.54 2.42 1.31 2.42-1.31.96-.54c16.31-8.75 27.74-21.91 33.96-40.41 5.22-15.12 4.8-27.94 4.76-28.47z"
        ></path>
        <path
          fill="#001f4e"
          d="M23.97 55.06c.65 4.57 1.8 15.08 3.76 20.84 6.22 18.5 17.65 31.66 33.96 40.41l.96.54 2.42 1.31 2.42-1.31.96-.54c16.31-8.75 27.74-21.91 33.96-40.41 2.03-6.03 3.19-16.65 3.84-21.34l-82.27.5z"
        ></path>
        <path
          fill="url(#c)"
          d="M62 117.69L65.26 119.69 68.25 117.84 68.25 75.36 62 75.36 62 117.69z"
        ></path>
        <path
          fill="url(#d)"
          d="M73.24 115.35L79.5 111.47 79.5 75.36 73.24 75.36 73.24 115.35z"
        ></path>
        <path
          fill="url(#e)"
          d="M84.48 75.36L84.48 106.76 90.7 100.27 90.7 75.36 84.48 75.36z"
        ></path>
        <path
          fill="url(#f)"
          d="M50.79 111.32L57.05 115.2 57.05 75.36 50.79 75.36 50.79 111.32z"
        ></path>
        <path
          fill="url(#g)"
          d="M39.55 100.11L45.8 106.26 45.8 75.36 39.55 75.36 39.55 100.11z"
        ></path>
        <path
          fill="#001f4e"
          d="M86.29 57.94c-11.47 11.7-30.24 11.9-41.94.42-11.7-11.47-11.9-30.24-.42-41.94C55.4 4.72 74.17 4.52 85.87 16s11.9 30.24.42 41.94z"
        ></path>
        <path
          fill="#97b6cb"
          d="M84.72 56.41c-10.63 10.82-28.01 11.01-38.83.38-10.82-10.63-11.01-28.01-.38-38.83 10.63-10.82 28.01-11.01 38.83-.38 10.82 10.59 11.01 28.01.38 38.83z"
        ></path>
        <path
          fill="#fff"
          d="M83.45 55.14c-9.94 10.13-26.17 10.29-36.3.38-10.13-9.94-10.29-26.17-.38-36.3 9.9-10.13 26.17-10.29 36.3-.38 10.13 9.94 10.29 26.17.38 36.3z"
        ></path>
        <path
          fill="#022150"
          d="M82.6 54.34c-9.48 9.67-24.98 9.82-34.69.35-9.67-9.48-9.82-25.02-.35-34.69 9.48-9.67 25.02-9.82 34.69-.35 9.67 9.52 9.82 25.02.35 34.69z"
        ></path>
        <path
          fill="#fff"
          d="M79.19 19.26c4.22 4.57 6.26 7.64 6.26 7.64l-4.76.04-8.17-3.22-1.92-5.95 1.38-2.3s4.91 1.31 7.22 3.8zM67.83 14.54l2.76 3.22-3.61 4.53-8.6-.46-5.53-1.61 3.53-4.14s5.41-2.5 11.44-1.53zM44.15 28.13l1.96-1.53 1.42 6.37.84 9.98-4.68 2.07s-3.53-7.91.46-16.89z"
        ></path>
        <path
          fill="#fff"
          d="M43.69 45.01l6.33 2.84 5.1 7.14-1.73 1.76s-6.72-3.53-9.71-11.74z"
        ></path>
        <path
          fill="#fff"
          d="M54.86 49.19l9.44.35 8.25 2.99s-3.65 6.68-5.49 7.41c0 0-3.8.65-7.44-.57l-4.49-4.34s-1.11-3.99-.27-5.83z"
        ></path>
        <path
          fill="#fff"
          d="M81.15 53.38l-4.18-.61-9.9 7.14s8.21-.57 14.08-6.52zM87.9 37.6l-3.38 3.45-4.03 8.02.69 4.3s5.91-5.07 6.72-15.77z"
        ></path>
        <path
          fill="#fff"
          d="M80.72 26.94L85.56 32.5 84.48 41.06 79.3 45.51 74.47 38.6 74.12 28.55 80.72 26.94z"
        ></path>
        <path
          fill="#fff"
          d="M68.29 30.7L74.47 38.6 73.86 47.81 64.3 49.54 56.2 44.67 60.23 35.69 68.29 30.7z"
        ></path>
        <path
          fill="#fff"
          d="M59.04 21.87L64.53 27.01 60.23 35.69 51.98 40.52 47.53 32.96 50.14 23.87 59.04 21.87z"
        ></path>
        <path
          fill="#ccc"
          d="M73.09 22.1l.27.84 7.56 2.99h2.57c-.23-.31-.5-.65-.81-1.04h-2.53l-7.06-2.8z"
        ></path>
        <path
          fill="#ccc"
          d="M57.81 19.8L55.21 19.07 54.67 19.72 58.58 20.83 66.52 21.26 69.25 17.8 68.6 17 65.99 20.26 57.81 19.8z"
        ></path>
        <path
          fill="#ccc"
          d="M46.96 41.14l-3.03 1.34c.12.46.23.84.35 1.15l3.03-1.34-.77-9.17-1.04-4.72-.04.04.73 3.3.77 9.4zM70.17 52.72c-1.42 2.34-3.03 4.64-3.91 5.1l-.04.04h-.08c-.31.04-1.15.15-2.23.15-1.61 0-3.19-.23-4.53-.65l-.08-.04L56 54.1c.04.12.04.19.08.31l4.11 3.95c1.31.42 2.84.61 4.41.61 1.07 0 1.88-.12 2.19-.15.84-.46 2.76-3.19 4.3-5.83l-.92-.27zM71.59 57.9c2.19-.69 4.84-1.88 7.25-3.84l-1.61-.23c-.12.08-.19.15-.31.23l-5.33 3.84zM86.48 40.48l-.84.84c-1.04 3.88-2.69 6.64-4.07 8.4l.23 1.38c1.46-1.8 3.72-5.33 4.68-10.63z"
        ></path>
        <path
          fill="#ccc"
          d="M84.48 32.85L84.02 32.35 83.18 39.37 78.84 43.05 79.5 44.01 83.53 40.56 84.48 32.85z"
        ></path>
        <path
          fill="#ccc"
          d="M64.49 48.46L72.9 46.97 73.43 38.91 73.05 38.41 72.51 45.89 63.76 47.47 57.7 43.82 57.51 44.28 64.49 48.46z"
        ></path>
        <path
          fill="#ccc"
          d="M51.75 38.14L52.37 39.14 59.47 35 63.26 27.21 62.61 26.59 59.04 33.84 51.75 38.14z"
        ></path>
        <path
          fill="#001f4e"
          d="M14.8 77.74H115.64999999999999V89.86999999999999H14.8z"
        ></path>
        <path
          fill="#fff"
          d="M23.28 81.93h-1.65l-.19-.65h-1.23l-.23.19v.38l.19.15 2.15.35 1.04.81v1.76l-1.27 1.04h-2.65l-1.27-1.04v-1.11h1.65l.19.65h1.31l.23-.19v-.42l-.15-.15-2.11-.35-1.07-.88v-1.69l1.19-1h2.72l1.19 1-.04 1.15zM29.19 85.42c-.23.19-.46.38-.69.54h-2.53l-1.34-1.11v-4.03l1.31-1.07h2.65l1.31 1.07v4.03l-.69.57zm-2.5-4.14l-.23.19v2.76l.23.19h1.07l.23-.19v-2.76l-.23-.19h-1.07zM36.32 81.93h-1.65l-.19-.65h-1.23l-.27.19v2.72l.27.19h1.23l.19-.65h1.65v1.11c-.19.19-.42.35-.61.54-.23.19-.42.35-.61.54h-2.46l-1.42-1.19v-3.88l1.38-1.15h2.57l1.19 1-.04 1.23zM42.77 81.93h-1.65l-.19-.65H39.7l-.27.19v2.72l.27.19h1.23l.19-.65h1.65v1.11c-.19.19-.42.35-.61.54-.23.19-.42.35-.61.54h-2.5l-1.42-1.19v-3.88l1.38-1.15h2.57l1.19 1v1.23zM48.26 81.93l-.19-.65h-1.5v1h1.5v1.07h-1.5v1.07h1.5l.19-.65h1.31v2.19h-5.49v-1.34l.69-.19v-3.15l-.69-.19v-1.34h5.45v2.19h-1.27zM50.87 85.96v-1.34l.69-.19v-3.15l-.69-.19v-1.34h4.6l1.19 1v1.84l-.88.73.69 1.07.46.08v1.42h-1.69l-1.42-2.42h-.46v.88l.69.19v1.34l-3.19.08zm2.53-3.65h1.27l.23-.19v-.65l-.23-.19H53.4v1.04zM68.25 84.61v1.34H65.1v-1.34l.46-.19-.15-.54h-1.34l-.15.54.42.19v1.34h-2.65v-1.34l.69-.19.92-3.15-.57-.19v-1.34h3.57l1.19 4.68.77.19zm-3.91-1.8h.77l-.38-1.38-.38 1.38zM74.55 81.93H72.9l-.19-.65h-1.23l-.27.19v2.72l.27.19h1.23l.19-.65h1.65v1.11c-.19.19-.42.35-.61.54s-.42.35-.61.54h-2.46l-1.42-1.19v-3.88l1.38-1.15h2.57l1.19 1-.04 1.23zM82.3 84.61v1.34h-3.15v-1.34l.46-.19-.15-.54h-1.34l-.15.54.42.19v1.34h-2.65v-1.34l.69-.19.92-3.15-.57-.19v-1.34h3.57l1.19 4.68.77.19zm-3.91-1.8h.77l-.38-1.38-.38 1.38zM87.63 85.96h-4.26v-1.34l.69-.19v-3.15l-.69-.19v-1.34h4.3l1.53 1.31v3.61l-1.57 1.31zm-1.73-1.53h1.11l.38-.31v-2.53l-.38-.31h-1.15l.04 3.15zM94.69 81.93l-.19-.65H93v1h1.5v1.07H93v1.07h1.5l.19-.65H96v2.19h-5.49v-1.34l.69-.19v-3.15l-.69-.19v-1.34h5.45v2.19h-1.27zM104.4 81.27v3.15l.65.19v1.34h-3.26v-1.34l.84-.19v-2.11l-1.11 1.92h-.69l-1.11-1.92v2.11l.84.19v1.34H97.3v-1.34l.69-.19v-3.15l-.69-.19v-1.34h2.92l1.04 1.92 1.07-1.92h2.72v1.34l-.65.19zM111.54 81.27l-1.5 2v1.15l.77.19v1.34h-3.34v-1.34l.77-.19v-1.11l-1.53-2.03-.54-.19v-1.34h2.88v1.34l-.38.19.69 1.04.69-1.04-.38-.19v-1.34h2.46v1.34l-.57.19z"
        ></path>
        <path
          fill="#001f4e"
          d="M117.87 80.01c-.81 3.72-1.27 7.48-1.38 11.2-2.3-.38-4.72-.54-7.22-.42.15.77.35 1.53.5 2.3 5.26-.88 10.32-.42 14.77 1-.54-1.88-1.15-3.72-1.84-5.56a35.06 35.06 0 015.87-5.72 41.18 41.18 0 00-10.71-2.8zM12.46 80.05c.81 3.72 1.27 7.48 1.38 11.2 2.3-.38 4.72-.54 7.22-.42-.15.77-.35 1.53-.5 2.3-5.26-.88-10.32-.42-14.77 1 .54-1.88 1.15-3.72 1.84-5.56a35.06 35.06 0 00-5.87-5.72c3.3-1.38 6.91-2.34 10.71-2.8z"
        ></path>
        <path
          fill="#cad4d8"
          d="M29.23 33.88l1.57 4.87h2.15c-.15-3.11.15-6.26.88-9.29-2.3.88-4.26 1.73-5.79 2.5l-2.5 1.19v5.6h2.07l1.61-4.87zM31.8 41.79l1.57 4.87-4.14-3.03-3.68 2.65v1.19s-.04.84 0 2.34h.88c.19 0 .42.04.61.04v-.04h8.44a32.79 32.79 0 01-2.38-9.02l-1.31 1zM100.99 33.88l-1.57 4.87h-2.15c.15-3.11-.15-6.26-.88-9.29 2.3.88 4.26 1.73 5.79 2.5l2.5 1.19v5.6h-2.07L101 33.88zM98.38 41.79l-1.57 4.87 4.14-3.03 3.68 2.65v1.19s.04.84 0 2.34h-.88c-.19 0-.42.04-.61.04v-.04H94.7a32.79 32.79 0 002.38-9.02l1.31 1z"
        ></path>
        <path
          fill="#001f4e"
          d="M100.99 36.03L99.87 39.45 96.3 39.45 99.18 41.52 98.07 44.93 100.99 42.82 103.86 44.93 102.75 41.52 105.63 39.45 102.06 39.45 100.99 36.03z"
        ></path>
        <path
          fill="#001f4e"
          d="M29.23 36.03L30.34 39.45 33.91 39.45 31.03 41.52 32.1 44.93 29.23 42.82 26.35 44.93 27.46 41.52 24.58 39.45 28.15 39.45 29.23 36.03z"
        ></path>
        <path
          fill="#001f4e"
          d="M120.63 56.64v-8.33H84.44l-.04.04v-.04H.98v8.33h2l3.88 21.45h107.91l3.88-21.45h2z"
        ></path>
        <path
          fill="#001f4e"
          d="M125.01 69.72L122.48 56.64 122.78 56.64 122.78 48.27 111.23 48.27 111.23 56.64 111.58 56.64 109.04 69.72 107.12 69.72 107.12 78.09 126.77 78.09 126.77 69.72 125.01 69.72z"
        ></path>
        <path
          fill="#526f9a"
          d="M11.38 54.61L12.57 54.61 10.96 63.74 9.31 54.61 10.5 54.61 10.5 50.31 3.02 50.31 3.02 54.61 4.67 54.61 8.54 76.05 13.34 76.05 17.21 54.61 18.9 54.61 18.9 50.31 11.38 50.31 11.38 54.61z"
        ></path>
        <path
          fill="#526f9a"
          d="M19.44 54.61L20.9 54.61 20.9 71.76 19.44 71.76 19.44 76.05 27 76.05 27 71.76 25.54 71.76 25.54 54.61 27 54.61 27 50.31 19.44 50.31 19.44 54.61z"
        ></path>
        <path
          fill="#526f9a"
          d="M34.87 71.76L33.6 71.76 33.6 54.61 34.98 54.61 34.98 50.31 27.5 50.31 27.5 54.61 28.92 54.61 28.92 71.76 27.5 71.76 27.5 76.05 39.55 76.05 39.55 68.11 34.87 68.11 34.87 71.76z"
        ></path>
        <path
          fill="#526f9a"
          d="M46.96 71.76L45.69 71.76 45.69 54.61 47.11 54.61 47.11 50.31 39.59 50.31 39.59 54.61 41.05 54.61 41.05 71.76 39.59 71.76 39.59 76.05 51.64 76.05 51.64 68.11 46.96 68.11 46.96 71.76z"
        ></path>
        <path
          fill="#526f9a"
          d="M74.7 54.49l-1.31-4.18h-6.37v4.3h1.42v17.15h-2.61l-3.3-17.15h.77v-4.3h-7.52v4.3h.81l-3.34 17.15h-1.53v4.3h7.17v-4.3h-1.27l.61-3.11h2.76l.61 3.11h-1.46v4.3h14.39v-4.3h-1.42v-6.75l3.41 11.05h4.49V54.61h1.38v-4.3h-7.71v4.18zM59 64.31l.54-2.72.54 2.72h-1.07zm17.34-9.71v5.26l-1.61-5.26h1.61zM86.29 50.31l-2.8 3.19v19.34l2.8 3.19h6.37l2.69-3.22V53.47l-2.69-3.22-6.37.08zm4.38 21.45h-2.53V54.61h2.53v17.15z"
        ></path>
        <path
          fill="#526f9a"
          d="M104.59 54.61L105.78 54.61 104.13 63.74 102.52 54.61 103.71 54.61 103.71 50.31 96.23 50.31 96.23 54.61 97.88 54.61 101.75 76.05 106.55 76.05 110.43 54.61 112.11 54.61 112.11 50.31 104.59 50.31 104.59 54.61z"
        ></path>
        <path
          fill="#526f9a"
          d="M123.32 71.76l-3.3-17.15h.77v-4.3h-7.52v4.3h.77l-3.34 17.15h-1.53v4.3h7.17v-4.3h-1.31l.61-3.11h2.76l.61 3.11h-1.34v4.3h7.1v-4.3h-1.46zm-6.83-7.44l.54-2.72.54 2.72h-1.07z"
        ></path>
        <path
          fill="#fff"
          d="M9.69 53.8H8.35l2.5 13.85h.23l2.46-13.85H12.2v-2.69h5.91v2.69h-1.53L12.7 75.25H9.25L5.37 53.8H3.84v-2.69h5.87v2.69zM20.28 72.56h1.42V53.79h-1.42V51.1h5.91v2.69h-1.42v18.77h1.42v2.69h-5.91v-2.69zM34.18 53.8H32.8v18.77h2.88v-3.65h3.07v6.37H28.31V72.6h1.42V53.83h-1.42v-2.69h5.87v2.65zM46.3 53.8h-1.38v18.77h2.88v-3.65h3.07v6.37H40.43V72.6h1.42V53.83h-1.42v-2.69h5.87v2.65zM52.48 72.56h1.38l3.65-18.77h-.96V51.1h5.91v2.69h-.92l3.65 18.77h1.31v2.69h-5.49v-2.69h1.53l-.92-4.72h-4.14l-.92 4.72h1.46v2.69h-5.53v-2.69zm5.53-7.44H61l-1.5-7.79-1.5 7.79zM72.82 51.11l4.38 14.08v-11.4h-1.69V51.1h6.14v2.69h-1.38v21.45H77.2l-4.84-15.58v12.89h1.42v2.69h-5.91v-2.69h1.42V53.78h-1.42v-2.69h4.95zM94.54 53.8v18.77l-2.26 2.69h-5.64l-2.34-2.69V53.8l2.34-2.69h5.64l2.26 2.69zm-3.07 18.77V53.8h-4.14v18.77h4.14zM102.9 53.8h-1.38l2.5 13.85h.23l2.46-13.85h-1.34v-2.69h5.91v2.69h-1.53l-3.88 21.45h-3.45L98.54 53.8h-1.53v-2.69h5.87v2.69h.04zM109.96 72.56h1.38l3.65-18.77h-.96V51.1h5.91v2.69h-.92l3.65 18.77h1.31v2.69h-5.49v-2.69h1.53l-.92-4.72h-4.11l-.92 4.72h1.46v2.69h-5.56v-2.69zm5.53-7.44h2.99l-1.5-7.79-1.5 7.79z"
        ></path>
        <path
          fill="#cad4d8"
          d="M9.62 74.75L7.47 62.82 9.46 62.82 10.42 68.15 11.46 68.15 12.42 62.82 14.45 62.82 12.26 74.75 9.62 74.75z"
        ></path>
        <path
          fill="#cad4d8"
          d="M20.75 74.75L20.75 73.02 22.17 73.02 22.17 62.82 24.28 62.82 24.28 73.02 25.69 73.02 25.69 74.75 20.75 74.75z"
        ></path>
        <path
          fill="#cad4d8"
          d="M28.77 74.75L28.77 73.02 30.22 73.02 30.22 62.82 32.29 62.82 32.29 73.02 36.13 73.02 36.13 69.38 38.24 69.38 38.24 74.75 28.77 74.75z"
        ></path>
        <path
          fill="#cad4d8"
          d="M40.89 74.75L40.89 73.02 42.31 73.02 42.31 62.82 44.42 62.82 44.42 73.02 48.26 73.02 48.26 69.38 50.37 69.38 50.37 74.75 40.89 74.75z"
        ></path>
        <path
          fill="#cad4d8"
          d="M61.46 74.75L61.46 73.02 63.07 73.02 61.96 67.35 57.09 67.35 55.97 73.02 57.55 73.02 57.55 74.75 52.94 74.75 52.94 73.02 54.28 73.02 56.28 62.82 57.97 62.82 57.43 65.58 61.61 65.58 61.08 62.82 62.8 62.82 64.8 73.02 65.99 73.02 65.99 74.75 61.46 74.75z"
        ></path>
        <path
          fill="#cad4d8"
          d="M68.33 74.75L68.33 73.02 69.75 73.02 69.75 62.82 71.86 62.82 71.86 73.02 73.28 73.02 73.28 74.75 68.33 74.75z"
        ></path>
        <path
          fill="#cad4d8"
          d="M77.5 74.75L73.82 62.82 75.93 62.82 76.73 65.39 77.65 65.27 77.65 62.82 79.77 62.82 79.77 74.75 77.5 74.75z"
        ></path>
        <path
          fill="#cad4d8"
          d="M86.86 74.75L84.79 72.37 84.79 62.82 86.86 62.82 86.86 73.02 91.97 73.02 91.97 62.82 94.08 62.82 94.08 72.37 92.08 74.75 86.86 74.75z"
        ></path>
        <path
          fill="#cad4d8"
          d="M102.83 74.75L100.68 62.82 102.67 62.82 103.63 68.15 104.67 68.15 105.63 62.82 107.62 62.82 105.47 74.75 102.83 74.75z"
        ></path>
        <path
          fill="#cad4d8"
          d="M118.94 74.75L118.94 73.02 120.6 73.02 119.44 67.35 114.57 67.35 113.5 73.02 115.03 73.02 115.03 74.75 110.43 74.75 110.43 73.02 111.77 73.02 113.76 62.82 115.45 62.82 114.91 65.58 119.1 65.58 118.56 62.82 120.29 62.82 122.28 73.02 123.47 73.02 123.47 74.75 118.94 74.75z"
        ></path>
      </g>
    </svg>
  );
};

// AJ Football Factory Icon
export const AjFootballFactoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="max-w-[100px] md:max-w-[130px]"
      width="130"
      height="105"
      fill="none"
      viewBox="0 0 130 105"
    >
      <path
        fill="none"
        strokeWidth="0"
        d="M67.8 14.99c3.11 0 5.64-3.19 5.64-7.12S70.92.75 67.8.75c-3.11 0-5.64 3.19-5.64 7.12s2.52 7.12 5.64 7.12M82.9 15.14c2.48 0 4.49-2.49 4.49-5.55s-2.01-5.55-4.49-5.55-4.49 2.49-4.49 5.55 2.01 5.55 4.49 5.55M43.34 15.93c2.51 0 4.55-2.41 4.54-5.37 0-2.96-2.05-5.35-4.56-5.35s-4.55 2.41-4.54 5.37c0 2.96 2.05 5.35 4.56 5.35M67.18 16.39c-1.98-.44-3.87-.52-5.66-.25-3.5.54-6.77 2.09-9.81 4.15-2.51 1.7-5.02 3.71-7.53 6.04-.11.1-.09.16.05.19l2.36.5c.09.02.18 0 .26-.04 1.76-.93 3.48-1.8 5.41-2.38 1.63-.49 3.57-.76 5.16-.29 3.24.95 4.07 4.33 4.2 7.36 0 .07.05.14.12.16 2.86 1.02 5.73 2.04 8.6 3.07.43.16.86.29 1.29.39.06.01.12-.02.14-.08v-.04c-.13-.97-.2-1.9-.23-2.79-.04-1.21.02-2.51.58-3.59.54-1.06 1.66-1.27 2.73-.96 1.37.4 2.59 1.22 3.7 2.08 1.02.79 2.14 1.79 3.36 3.03a53.62 53.62 0 013.38 3.74c.17.21.42.34.67.18.28-.19.15-.55.04-.8-1.59-3.76-3.19-7.25-5.5-10.56-3.24-4.63-7.58-7.65-13.02-9.03-.1-.02-.2-.05-.3-.07"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        strokeWidth="0"
        d="M91.17 25.65c2.13 1.03 4.12 2.87 5.81 4.62 2.06 2.13 3.99 4.32 5.79 6.58.58.73 1.6.05 1.06-.7-.36-.51-.76-1.02-1.1-1.55-2.3-3.52-4.24-6.41-5.84-8.67-.68-.97-1.54-2.02-2.57-3.17-2.32-2.58-4.93-4.66-8.14-5.71-2.18-.71-4.53-.79-6.79-.49-1.59.21-3.04.75-4.35 1.63-.05.03-.06.09-.03.14 0 .01.02.02.03.03 5.36 3.47 8.62 9.1 11.1 14.86.29.69.59 1.35.89 1.98.47 1 .58 1.87-.25 2.67-.02.02-.02.05 0 .08 0 0 .02.02.04.02l2.9.09c.06 0 .12-.05.12-.11v-.04a57.91 57.91 0 01-1.59-6.72c-.23-1.31-.82-5.45 1.16-5.85.52-.11 1.11 0 1.78.32M51.54 18.33c-4.44-1.99-9.33-1.58-13.39 1.12-2.3 1.53-4.17 3.49-5.85 5.73-.01.02 0 .05 0 .06h.03c3.45-.02 6.89.3 10.31.94.05 0 .09 0 .12-.06.14-.32.39-.63.73-.94 2.74-2.38 5.41-4.63 8.43-6.55.04-.03.06-.08.03-.13-.01-.02-.03-.03-.05-.04-.12-.04-.25-.09-.38-.15"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        strokeWidth="0"
        d="M129.17 33.13c-2.14.72-4.27 1.45-6.44 2.08-3.23.92-6.36 1.7-9.37 2.35-2.42.52-4.99.94-7.29 1.29-6.07.92-12.14 1.27-18.23 1.06-4.76-.17-9.44-.82-14.05-1.97-1.16-.28-2.1-.56-2.84-.82-3.93-1.38-8.05-2.85-12.39-4.39-2.23-.8-4.9-1.68-8.04-2.64-1.21-.37-2.45-.67-3.67-.99-2.78-.74-5.69-1.28-8.75-1.61-5.95-.65-11.73-.16-17.35 1.48-1.29.38-2.61.78-3.84 1.24-3 1.13-5.88 2.47-8.63 4-.22.12-.21.14.03.07 1.78-.55 3.42-1.01 4.91-1.38 7-1.73 14.19-2.42 21.3-1.32 4.1.64 7.92 1.62 11.77 2.85 2.72.87 6.02 1.98 9.89 3.35.92.32 1.94.68 3.07 1.07 2.61.9 5.16 1.76 7.66 2.58 1.1.36 2.16.66 3.17.89 2.8.64 5.58 1.13 8.44 1.36 1.72.14 3.09.22 4.12.24 4.5.12 8.59-.06 12.25-.52 6.61-.84 13.37-2.41 20.27-4.72 5.1-1.71 9.77-3.55 14.01-5.53.13-.06.12-.07 0-.02"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        strokeWidth="0"
        d="M79.39 33.74c-.43.99-.98 1.97-1.63 2.94-.04.06-.02.14.03.18.01 0 .03.02.05.02 2.23.42 4.44.72 6.64.9.01 0 .02 0 .02-.02v-.02a51.662 51.662 0 00-4.64-5.08.093.093 0 00-.13 0c-.01.01-.02.03-.02.05-.06.35-.17.7-.32 1.03"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        strokeWidth="0"
        d="M47.42 38.92c-.23-.07-.45-.14-.69-.21-2.2-.68-4.31-1.26-6.31-1.75a63.13 63.13 0 00-8.6-1.52c-5.92-.62-11.72-.15-17.39 1.42-4.92 1.36-9.65 3.35-14.19 5.97-.01 0-.02.02-.01.03s.02.02.03.01c3.22-1.26 6.51-2.25 9.87-3a49.122 49.122 0 0117-.78c3.57.46 7.17 1.2 10.8 2.22 2.16.6 4.1 1.19 5.83 1.75.95.31 1.9.58 2.84.9 4.91 1.64 9.81 3.26 14.71 4.86.79.26 1.59.49 2.4.69 4.55 1.12 9.17 1.74 13.87 1.88 6.79.19 13.46-.42 20.01-1.83.93-.2 1.88-.39 2.8-.61 6.5-1.59 12.74-3.7 18.7-6.33 1.87-.83 4.09-1.87 6.66-3.13.32-.16.32-.17-.02-.04-10.57 4.21-21.96 6.96-33.31 7.92-3.88.32-7.86.4-11.95.21-3.57-.16-7.14-.62-10.72-1.37-1.88-.4-3.43-.81-4.65-1.24-1.01-.36-2.02-.7-3.03-1.03-1.02-.34-2.03-.68-3.03-1.04-2.73-.97-5.36-1.89-7.9-2.76-1.47-.5-2.71-.91-3.72-1.21"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        strokeWidth="0"
        d="M33.25 52.88c-.9 1.78-1.82 3.54-2.77 5.26-.11.2-.2.42-.25.65-.03.12.04.24.16.27h.11c.09-.02.17-.07.24-.13 1.52-1.36 3.13-2.94 4.84-4.75 2.28-2.42 4.29-4.47 6.02-6.16.9-.88 1.88-1.73 2.96-2.55.04-.03.04-.08.01-.12 0-.01-.02-.02-.04-.03-2.38-.8-4.7-1.49-6.95-2.09-.08-.02-.16.02-.18.1a88.389 88.389 0 01-4.16 9.56M52.39 47.88c-1.51-.52-3.08-1.04-4.72-1.57-.11-.04-.23.02-.27.14-.06.19-.12.37-.16.56-.52 2.36-.36 4.91 1.41 6.69.4.4.9.71 1.51.92 1.2.42 2.34.62 3.41.62 1.11 0 2.14-.1 3.11-.3 1.83-.36 3.87-.93 6.13-1.69 1.7-.57 3.83-.87 5.51-.23.75.29 1.37.64 1.85 1.07 3.73 3.33 7.59 6.72 11.58 10.19 1.71 1.49 3.34 2.96 4.9 4.4.18.16.36.3.56.4.12.06.27.02.34-.11a.32.32 0 00.03-.14.903.903 0 00-.13-.39c-3.01-5.01-6.02-9.99-9.02-14.96a.372.372 0 00-.3-.18c-1.33-.05-2.58-.12-3.72-.19-3.18-.2-6.18-.62-8.99-1.26-1.79-.41-3.43-.85-4.92-1.32-2.59-.81-5.29-1.7-8.09-2.66M99.92 58.21s.06.02.07 0l.19-.36v-.05l-4.14-6.93s-.03-.03-.05-.02l-3.77.62s-.05.03-.04.06c0 .01 0 .02.02.03l7.71 6.66"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        strokeWidth="0"
        d="M80.61 70.1c0-3.79-3.08-6.87-6.87-6.87s-6.87 3.08-6.87 6.87 3.08 6.87 6.87 6.87 6.87-3.08 6.87-6.87M92.4 80.47v-4.24c0-.06-.03-.09-.09-.09l-1.91-.02a.1.1 0 00-.1.1c-.02.36-.03.7-.03 1.03 0 3.11 0 6.23.02 9.36 0 .04.04.08.08.08h1.73c.08 0 .14-.07.14-.15s-.04-.58-.04-.58c-.01-.14.03-.16.13-.05 1.19 1.3 3.07 1.22 4.33.09 1.04-.93 1.14-2.69.79-3.94-.41-1.47-1.39-2.24-2.94-2.3-.78-.03-1.45.23-2 .77-.07.07-.11.06-.11-.05M108.53 76.23s-.04-.09-.09-.09h-1.95s-.09.04-.09.09V86.6s.04.09.09.09h1.95s.09-.04.09-.09V76.23M112.28 76.24c0-.06-.04-.1-.1-.1h-1.93c-.06 0-.1.04-.1.1v10.35c0 .06.04.1.1.1h1.93c.06 0 .1-.04.1-.1V76.24M61.47 82.93s.04-.09.09-.09h3.93s.09-.04.09-.08v-1.83s-.03-.09-.08-.09h-3.93s-.09-.05-.09-.1v-1.83s.03-.09.08-.09h4.27s.09-.04.09-.08v-1.82s-.03-.09-.08-.09h-6.49s-.09.04-.09.09v9.67s.04.09.08.09l2.05.02s.09-.04.09-.09v-3.68M30.31 84.37s.03-.02.05 0c.33.57.67 1.15 1.01 1.75 2.53 4.36 4.99 8.62 7.37 12.77.42.73 1.02 1.14 1.81 1.25.75.1 2.46.13 5.14.08 2.65-.04 4.98-1.24 6.6-3.31 1.12-1.43 1.72-3.01 1.81-4.74.04-.74.07-1.48.09-2.2.09-3.31.19-6.64.3-9.97.02-.67-.02-1.16-.13-1.47-.36-1.02-1.24-1.68-2.35-1.68-2.36-.01-4.21-.01-5.52 0-1.01.01-1.74.4-2.17 1.16-.35.61-.45 1.23-.31 1.84.35 1.47 1.36 1.97 2.81 1.94.87-.02 1.72-.01 2.56.02.04 0 .07.03.07.07-.07 3.33-.14 6.42-.21 9.28-.01.59-.08 1.08-.21 1.47-.38 1.17-1.11 1.97-2.2 2.39-.46.18-1.08.26-1.87.24-.78-.01-1.58-.02-2.42-.02a.26.26 0 01-.22-.13c-3.16-5.5-6.29-10.89-9.37-16.18-.74-1.27-1.29-2.23-3.03-2.04-1.02.11-1.58.86-2.06 1.71-3.23 5.65-6.68 11.5-10.04 17.35-.51.89-.82 1.61-.48 2.6.23.65.66 1.12 1.3 1.42.34.15.87.23 1.61.24 3.4.01 6.8 0 10.18-.01.35 0 .68-.08.98-.24 2.52-1.34 1.45-4.75-1.26-4.74-1.98 0-3.99 0-6.02-.01-.04 0-.07-.03-.07-.07v-.03c1.83-3.22 3.66-6.4 5.49-9.54.24-.4.48-.8.74-1.19M87.2 79.78v-1.76c0-.08-.07-.14-.15-.14h-1.88s-.09.04-.09.09v1.81c0 .08-.03.12-.11.12h-1.14c-.06 0-.11.05-.11.11l.02 1.5c0 .07.03.1.1.1l1.04-.03c.12 0 .22.09.22.21 0 .91 0 1.83-.02 2.79 0 .35.03.67.12.96.45 1.49 2.53 1.44 3.69 1.18.08-.02.13-.09.13-.17v-1.42c.01-.12-.04-.16-.16-.12-.44.16-1.3.22-1.52-.32-.08-.19-.12-.39-.13-.6-.01-.77-.02-1.56 0-2.38 0-.06.05-.11.11-.11h1.59c.07 0 .11-.03.11-.11v-1.48c0-.06-.04-.11-.1-.11h-1.58c-.07.01-.13-.04-.13-.12M74.52 83.31c0-1.98-1.69-3.59-3.79-3.6s-3.81 1.59-3.82 3.57c0 1.98 1.69 3.59 3.79 3.6 2.1 0 3.81-1.59 3.82-3.57M83.08 83.29c0-1.98-1.72-3.58-3.83-3.57-2.11 0-3.81 1.62-3.8 3.6 0 1.98 1.72 3.58 3.83 3.57 2.11 0 3.81-1.62 3.8-3.6M102.95 82.4c-.95-.02-1.8.06-2.55.24-1.02.24-1.62.81-1.81 1.69-.18.84.18 1.77.93 2.16.91.49 1.86.5 2.85.03.25-.12.41-.33.6-.5.09-.08.14-.06.14.06v.48c0 .07.05.12.11.12h1.77c.06 0 .11-.05.11-.11 0-1.27-.01-2.53-.03-3.77-.02-1.46-.57-2.76-2.16-2.98-1.55-.22-2.82.08-3.81.88-.09.08-.1.16-.02.24l.79.86c.13.14.27.15.41.01.69-.66 1.75-.88 2.5-.22.18.16.27.38.28.68 0 .08-.04.12-.12.12M61.47 96.38c0-.05.04-.09.09-.09l3.91.02c.05 0 .09-.04.09-.09v-1.88c0-.05-.03-.09-.08-.09h-3.92c-.05.01-.09-.03-.09-.08v-1.78c0-.05.03-.09.09-.09h4.25c.05 0 .09-.04.09-.09v-1.86a.09.09 0 00-.09-.09h-6.47a.09.09 0 00-.09.09v9.72c0 .05.04.09.09.09h2.03c.05 0 .09-.04.09-.09v-3.68M82.09 93.37l-1.05-.03c-.09 0-.14.04-.14.14l-.03 1.46s.04.09.08.09l1.16-.02c.08 0 .12.04.12.12v3.18c0 2.13 2.37 2.22 3.83 1.86.05-.01.09-.06.09-.11l.03-1.59s-.03-.06-.06-.06h-.02c-.72.27-1.67.26-1.75-.75-.06-.76-.07-1.61-.03-2.55 0-.06.03-.1.1-.09h1.65c.06.01.09-.02.09-.08v-1.52s-.03-.06-.07-.06l-1.65.02c-.1 0-.15-.05-.15-.14V91.4c0-.06-.03-.08-.09-.08h-1.9c-.06 0-.09.02-.09.08l-.03 1.86c0 .09-.05.13-.14.13M71.45 99.5l-.02.53c0 .08.04.13.12.13h1.73c.07 0 .11-.04.11-.12v-3.28c0-1.63-.28-3.21-2.21-3.5-1.44-.22-2.68.06-3.73.84-.12.09-.13.19-.03.3l.82.9c.1.12.21.12.32 0 .77-.82 2.67-1.06 2.85.42 0 .08-.02.11-.1.11-1.24-.06-3.82.11-4.3 1.59-.29.89-.15 1.63.4 2.19.99 1 3 .97 3.88-.16.11-.14.16-.12.16.06M77.05 97.78c-.73-1.09-.15-2.62 1.26-2.73.4-.03.73.11 1 .43.06.08.13.08.2 0l1.13-1.15c.11-.11.11-.29 0-.4-1.15-1.06-3.38-.88-4.57-.05-1.13.79-1.58 1.99-1.36 3.61.38 2.69 3.93 3.65 5.92 2.12.15-.12.16-.24.03-.38l-1.18-1.25s-.07-.03-.1 0c-.27.32-.68.55-1.12.48-.56-.08-.96-.31-1.2-.67M94.6 96.75c0-1.99-1.71-3.6-3.81-3.6s-3.81 1.61-3.81 3.6 1.71 3.6 3.81 3.6 3.81-1.61 3.81-3.6M98.06 94.2c-.12.19-.18.17-.18-.05v-.68c0-.08-.03-.12-.11-.12l-1.89.02a.09.09 0 00-.09.09v6.59c0 .06.05.11.11.11h1.89s.09-.05.09-.1c0-1.05 0-2.12.02-3.23.01-.65.19-1.36.82-1.62.49-.2 1.07-.23 1.72-.08.05.01.09-.02.1-.06v-.02l-.02-1.65c0-.1-.05-.16-.15-.17-.86-.13-1.56.07-2.08.6-.11.11-.17.25-.25.37M104.91 97.56c-.07.21-.15.21-.23 0l-1.53-3.96a.337.337 0 00-.34-.23l-1.9-.02c-.06 0-.11.04-.11.1v.04l2.85 6.57c.03.06.03.13.02.2-.1.44-.3.83-.59 1.17-.39.47-1.31.31-1.8.14-.04-.02-.09 0-.11.05v.02l-.23 1.54c-.01.07.02.12.09.14.68.18 1.38.23 2.12.16.85-.09 1.43-.44 1.8-1.21.53-1.12.92-2.28 1.37-3.43.72-1.81 1.42-3.6 2.11-5.36.02-.05 0-.11-.06-.13h-.04c-.6.04-1.22.04-1.86 0-.11 0-.22.06-.25.17l-1.32 4.05"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        strokeWidth="0"
        d="M73.77 63.96c-1.4 0-2.87.5-3.95 1.44-.02.02-.02.05 0 .07 0 0 .01.01.02.01.3.1.63.1.91-.07.8-.49 1.62-.76 2.46-.8.18 0 .33-.08.45-.22l.21-.24c.12-.14.09-.2-.09-.2"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        strokeWidth="0"
        d="M73.65 65.02c-.47-.56-2.51.37-3.03.76a.36.36 0 00-.12.18l-.39 1.55c-.02.06 0 .13.05.17L72 69.2c.05.04.11.06.17.04l2-.44c.06-.01.1-.05.12-.11.23-.8.41-1.57.55-2.31.01-.07 0-.13-.06-.18-.4-.37-.78-.76-1.14-1.19M79.58 68.28c-.37-1.36-1.32-2.51-2.51-3.33-.13-.09-.18-.05-.15.1l.07.5c.01.09.05.17.12.23.76.68 1.35 1.46 1.79 2.34.02.05.06.08.12.1l.49.14c.07.02.1 0 .08-.08"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        strokeWidth="0"
        d="M78.65 68.49c.19-.62-1.26-2.17-1.72-2.55-.04-.03-.09-.04-.14-.03l-1.57.42c-.09.02-.15.09-.17.18l-.49 2.31c-.01.05 0 .1.04.15l1.45 1.77c.05.06.11.08.18.06l1.83-.51c.08-.02.14-.09.16-.16.13-.52.27-1.06.44-1.62M70.06 72.81l1.59-.8a.18.18 0 00.1-.14l.16-2.18a.513.513 0 00-.18-.42l-1.71-1.41a.225.225 0 00-.27-.01c-.42.28-.84.52-1.27.71-.1.04-.17.13-.19.24-.12.65-.15 1.4-.11 2.28.01.26.06.49.13.7.02.05.06.1.11.13l1.48.89c.05.03.11.03.16 0M68.06 68.9c.05-.25.05-.49 0-.72-.03-.15-.07-.15-.11 0-.39 1.18-.41 2.4-.07 3.68 0 .04.05.06.09.05 0 0 .02 0 .03-.01l.03-.03s.01-.02.01-.03c-.13-.95-.17-2 .01-2.93M78.3 70.64a.202.202 0 00-.23-.11l-1.92.5c-.08.02-.15.06-.2.12l-1.51 1.68c-.05.06-.06.13-.03.2l.57 1.45c.03.07.08.11.15.11l2.5.13c.06 0 .12-.01.16-.05.58-.5 1.05-1.09 1.41-1.77.04-.07.04-.15 0-.23l-.91-2.03M71.86 72.19c-.57.2-1.15.56-1.67.85-.05.03-.08.07-.07.13v1.75c0 .08.04.15.11.2.72.49 1.96 1.09 2.81 1.03.06 0 .11-.02.15-.06l1.54-1.37s.06-.11.04-.17l-.59-1.46a.21.21 0 00-.13-.13l-2.02-.77s-.11-.02-.15 0M95.61 83.32c0-.93-.75-1.69-1.69-1.69s-1.69.75-1.69 1.69.75 1.69 1.69 1.69 1.69-.75 1.69-1.69M72.33 83.09c-.01-.81-.69-1.46-1.5-1.45h-.29c-.81.02-1.46.69-1.45 1.5v.4c.02.81.69 1.46 1.5 1.45h.29c.81-.02 1.46-.69 1.45-1.5v-.4M79.27 85.03c.91 0 1.65-.78 1.64-1.72 0-.95-.75-1.71-1.66-1.7-.91 0-1.65.78-1.64 1.72s.75 1.71 1.66 1.7M101.22 85.36c1.1.12 1.98-.25 1.9-1.5 0-.03-.03-.06-.06-.07-.65-.07-1.82-.04-2.3.49-.41.44-.06 1.03.47 1.08M71.33 97.17c-.71-.01-2.28 0-2.44.85-.22 1.22 2.71 1.24 2.54-.75 0-.06-.04-.09-.1-.09M90.79 98.46c.92 0 1.66-.78 1.66-1.73s-.76-1.71-1.68-1.7-1.66.78-1.66 1.73.76 1.71 1.68 1.7"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="#fc1817"
        strokeWidth="0"
        d="M67.8 14.99c-3.11 0-5.64-3.19-5.64-7.12S64.68.75 67.8.75c3.11 0 5.64 3.19 5.64 7.12s-2.52 7.12-5.64 7.12z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M82.9 15.14c-2.48 0-4.49-2.49-4.49-5.55s2.01-5.55 4.49-5.55 4.49 2.49 4.49 5.55-2.01 5.55-4.49 5.55zM43.34 15.93c-2.51 0-4.56-2.39-4.56-5.35 0-2.96 2.03-5.36 4.54-5.37 2.51 0 4.56 2.39 4.56 5.35 0 2.96-2.03 5.36-4.54 5.37z"
      ></path>
      <path
        fill="#fc1817"
        strokeWidth="0"
        d="M67.18 16.39c.1.02.2.05.3.07 5.44 1.39 9.78 4.4 13.02 9.03 2.31 3.31 3.92 6.81 5.5 10.56.11.25.24.61-.04.8-.25.17-.5.03-.67-.18-1-1.23-2.13-2.48-3.38-3.74-1.22-1.23-2.34-2.24-3.36-3.03-1.12-.86-2.33-1.68-3.7-2.08-1.07-.31-2.19-.1-2.73.96-.56 1.08-.62 2.38-.58 3.59.02.89.1 1.82.23 2.79 0 .06-.04.12-.1.13h-.04c-.42-.11-.85-.24-1.29-.39-2.87-1.03-5.74-2.05-8.6-3.07-.07-.02-.11-.09-.12-.16-.13-3.03-.95-6.41-4.2-7.36-1.59-.47-3.52-.2-5.16.29-1.93.58-3.65 1.45-5.41 2.38-.08.04-.17.06-.26.04l-2.36-.5c-.14-.03-.16-.1-.05-.19 2.51-2.32 5.02-4.33 7.53-6.04 3.04-2.06 6.31-3.62 9.81-4.15 1.79-.28 3.68-.19 5.66.25z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M91.17 25.65c-.67-.32-1.26-.43-1.78-.32-1.97.41-1.39 4.54-1.16 5.85.38 2.15.91 4.39 1.59 6.72.02.06-.02.13-.08.14h-.04l-2.9-.09s-.05-.02-.05-.06c0-.01 0-.03.02-.04.83-.8.72-1.67.25-2.67-.3-.63-.6-1.29-.89-1.98-2.48-5.76-5.73-11.39-11.1-14.86-.05-.03-.06-.09-.03-.14 0-.01.02-.02.03-.03 1.31-.87 2.77-1.42 4.35-1.63 2.26-.3 4.61-.22 6.79.49 3.21 1.05 5.82 3.13 8.14 5.71 1.03 1.14 1.88 2.2 2.57 3.17 1.6 2.26 3.55 5.15 5.84 8.67.34.52.74 1.04 1.1 1.55.55.76-.47 1.43-1.06.7-1.8-2.25-3.73-4.45-5.79-6.58-1.69-1.75-3.68-3.59-5.81-4.62zM51.54 18.33c.13.06.25.11.38.15.05.02.07.07.06.12 0 .02-.02.04-.04.05-3.02 1.91-5.7 4.17-8.43 6.55-.35.3-.59.61-.73.94-.02.05-.06.07-.12.06-3.42-.64-6.86-.96-10.31-.94-.02 0-.04-.02-.04-.04v-.03c1.68-2.24 3.55-4.19 5.85-5.73 4.06-2.7 8.94-3.11 13.39-1.12z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M129.18 33.15c-4.24 1.98-8.91 3.82-14.01 5.53-6.91 2.31-13.66 3.89-20.27 4.72-3.66.46-7.75.64-12.25.52-1.03-.03-2.4-.11-4.12-.24-2.87-.23-5.64-.72-8.44-1.36a35.83 35.83 0 01-3.17-.89c-2.5-.82-5.05-1.68-7.66-2.58l-3.07-1.07c-3.88-1.37-7.17-2.49-9.89-3.35-3.85-1.23-7.67-2.21-11.77-2.85-7.1-1.11-14.3-.41-21.3 1.32-1.49.37-3.13.83-4.91 1.38-.24.07-.25.05-.03-.07a63.3 63.3 0 018.63-4c1.24-.46 2.55-.86 3.84-1.24 5.62-1.64 11.4-2.14 17.35-1.48 3.06.34 5.98.87 8.75 1.61 1.22.33 2.46.62 3.67.99 3.13.97 5.81 1.84 8.04 2.64 4.34 1.55 8.46 3.01 12.39 4.39.74.26 1.68.53 2.84.82 4.61 1.14 9.3 1.8 14.05 1.97 6.08.22 12.16-.14 18.23-1.06 2.3-.35 4.87-.78 7.29-1.29 3.01-.64 6.14-1.43 9.37-2.35 2.18-.62 4.3-1.36 6.44-2.08.13-.04.14-.04 0 .02z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M79.39 33.74c.15-.34.25-.68.32-1.03 0-.05.06-.08.11-.07.02 0 .03.01.05.02 1.72 1.66 3.27 3.35 4.64 5.08v.03h-.02c-2.2-.18-4.41-.48-6.64-.9a.12.12 0 01-.1-.15c0-.02 0-.03.02-.05.65-.97 1.19-1.95 1.63-2.94z"
      ></path>
      <path
        fill="#fc1817"
        strokeWidth="0"
        d="M47.42 38.92c1.01.3 2.25.71 3.72 1.21 2.53.87 5.17 1.79 7.9 2.76 1 .36 2.01.7 3.03 1.04 1.01.33 2.02.68 3.03 1.03 1.22.43 2.77.84 4.65 1.24 3.58.75 7.15 1.21 10.72 1.37 4.09.19 8.08.12 11.95-.21 11.35-.95 22.74-3.71 33.31-7.92.34-.13.34-.12.02.04-2.57 1.26-4.78 2.3-6.66 3.13-5.96 2.63-12.2 4.74-18.7 6.33-.92.22-1.87.41-2.8.61a83.624 83.624 0 01-20.01 1.83c-4.7-.13-9.32-.76-13.87-1.88-.81-.2-1.61-.43-2.4-.69-4.9-1.6-9.81-3.22-14.71-4.86-.94-.31-1.89-.59-2.84-.9-1.73-.56-3.67-1.14-5.83-1.75a75.63 75.63 0 00-10.8-2.22c-5.69-.73-11.36-.47-17 .78-3.36.74-6.65 1.74-9.87 3-.01 0-.02 0-.03-.01s0-.03.01-.04c4.54-2.62 9.27-4.61 14.19-5.97 5.67-1.57 11.47-2.04 17.39-1.42 2.83.3 5.7.8 8.6 1.52 2 .49 4.1 1.08 6.31 1.75.24.07.46.14.69.21z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M33.25 52.88c1.6-3.17 2.99-6.35 4.16-9.56.03-.08.11-.12.18-.1 2.25.6 4.57 1.29 6.95 2.09.05.01.07.06.06.11 0 .02-.01.03-.03.04-1.07.82-2.06 1.67-2.96 2.55-1.73 1.69-3.74 3.75-6.02 6.16-1.71 1.81-3.32 3.39-4.84 4.75-.07.06-.15.11-.24.13a.236.236 0 01-.28-.16v-.11c.06-.23.14-.44.25-.65.94-1.72 1.87-3.48 2.77-5.26z"
      ></path>
      <path
        fill="#fc1817"
        strokeWidth="0"
        d="M52.39 47.88c2.81.96 5.5 1.85 8.09 2.66 1.49.47 3.13.91 4.92 1.32 2.82.65 5.81 1.07 8.99 1.26 1.15.07 2.39.14 3.72.19.13 0 .24.07.3.18 3 4.96 6.01 9.95 9.02 14.96.07.12.12.25.13.39.01.14-.08.26-.22.28-.05 0-.1 0-.14-.03-.2-.1-.38-.24-.56-.4a229.36 229.36 0 00-4.9-4.4c-3.98-3.47-7.85-6.87-11.58-10.19-.48-.43-1.1-.79-1.85-1.07-1.68-.64-3.81-.35-5.51.23-2.26.76-4.31 1.33-6.13 1.69-.97.19-2 .29-3.11.3-1.08 0-2.21-.2-3.41-.62-.61-.21-1.11-.52-1.51-.92-1.77-1.78-1.93-4.33-1.41-6.69.04-.18.1-.37.16-.56.04-.11.16-.17.27-.14 1.64.53 3.22 1.05 4.72 1.57z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M99.92 58.21l-7.71-6.66s-.02-.05 0-.07c0 0 .02-.02.03-.02l3.77-.62s.04 0 .05.02l4.14 6.93v.05l-.19.36s-.05.03-.07.02z"
      ></path>
      <path
        strokeWidth="0"
        d="M80.61 70.1c0 3.79-3.08 6.87-6.87 6.87s-6.87-3.08-6.87-6.87 3.08-6.87 6.87-6.87 6.87 3.08 6.87 6.87zm-6.84-6.14c-1.4 0-2.87.5-3.95 1.44-.02.02-.02.05 0 .07 0 0 .01.01.02.01.3.1.63.1.91-.07.8-.49 1.62-.76 2.46-.8.18 0 .33-.08.45-.22l.21-.24c.12-.14.09-.2-.09-.2zm-.13 1.06c-.47-.56-2.51.37-3.03.76a.36.36 0 00-.12.18l-.39 1.55c-.02.06 0 .13.05.17l1.84 1.52c.05.04.11.06.17.04l2-.44c.06-.01.1-.05.12-.11.23-.8.41-1.57.55-2.31.01-.07 0-.13-.06-.18-.4-.37-.78-.76-1.14-1.19zm5.93 3.26c-.37-1.36-1.32-2.51-2.51-3.33-.13-.09-.18-.05-.15.1l.07.5c.01.09.05.17.12.23.76.68 1.35 1.46 1.79 2.34.02.05.06.08.12.1l.49.14c.07.02.1 0 .08-.08zm-.93.22c.19-.62-1.26-2.17-1.72-2.55-.04-.03-.09-.04-.14-.03l-1.57.42c-.09.02-.15.09-.17.18l-.49 2.31c-.01.05 0 .1.04.15l1.45 1.77c.05.06.11.08.18.06l1.83-.51c.08-.02.14-.09.16-.16.13-.52.27-1.06.44-1.62zm-8.59 4.32l1.59-.8a.18.18 0 00.1-.14l.16-2.18a.513.513 0 00-.18-.42l-1.71-1.41a.225.225 0 00-.27-.01c-.42.28-.84.52-1.27.71-.1.04-.17.13-.19.24-.12.65-.15 1.4-.11 2.28.01.26.06.49.13.7.02.05.06.1.11.13l1.48.89c.05.03.11.03.16 0zm-2-3.91c.05-.25.05-.49 0-.72-.03-.15-.07-.15-.11 0-.39 1.18-.41 2.4-.07 3.68 0 .04.05.06.09.05 0 0 .02 0 .03-.01l.03-.03s.01-.02.01-.03c-.13-.95-.17-2 .01-2.93zm10.24 1.74a.202.202 0 00-.23-.11l-1.92.5c-.08.02-.15.06-.2.12l-1.51 1.68c-.05.06-.06.13-.03.2l.57 1.45c.03.07.08.11.15.11l2.5.13c.06 0 .12-.01.16-.05.58-.5 1.05-1.09 1.41-1.77.04-.07.04-.15 0-.23l-.91-2.03zm-6.44 1.55c-.57.2-1.15.56-1.67.85-.05.03-.08.07-.07.13v1.75c0 .08.04.15.11.2.72.49 1.96 1.09 2.81 1.03.06 0 .11-.02.15-.06l1.54-1.37s.06-.11.04-.17l-.59-1.46a.21.21 0 00-.13-.13l-2.02-.77s-.11-.02-.15 0z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M69.82 65.4c1.08-.95 2.54-1.44 3.95-1.44.18 0 .21.07.09.2l-.21.24c-.12.14-.27.21-.45.22-.84.04-1.66.31-2.46.8-.28.17-.6.17-.91.07-.03 0-.04-.04-.03-.06 0 0 0-.02.01-.02z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M70.62 65.78c.52-.39 2.56-1.32 3.03-.76.36.42.74.82 1.14 1.19.05.05.07.11.06.18-.14.74-.32 1.51-.55 2.31-.02.06-.06.09-.12.11l-2 .44c-.06.01-.12 0-.17-.04l-1.84-1.52s-.07-.11-.05-.17l.39-1.55c.02-.07.06-.14.12-.18zM77.07 64.95c1.18.82 2.14 1.97 2.51 3.33.02.07 0 .1-.08.08l-.49-.14c-.05-.01-.09-.05-.12-.1a7.613 7.613 0 00-1.79-2.34.347.347 0 01-.12-.23l-.07-.5c-.02-.15.03-.18.15-.1z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M78.65 68.49c-.17.56-.31 1.1-.44 1.62-.02.08-.08.14-.16.16l-1.83.51c-.07.02-.14 0-.18-.06l-1.45-1.77s-.05-.09-.04-.15l.49-2.31c.02-.09.08-.16.17-.18l1.57-.42s.1 0 .14.03c.46.38 1.91 1.93 1.72 2.55zM71.66 72.01l-1.59.8c-.05.03-.11.02-.16 0l-1.48-.89s-.09-.08-.11-.13c-.08-.21-.12-.45-.13-.7-.04-.87 0-1.63.11-2.28.02-.11.09-.2.19-.24.43-.19.85-.42 1.27-.71.08-.06.19-.05.27.01l1.71 1.41c.12.1.19.26.18.42l-.16 2.18c0 .06-.04.11-.1.14zM68.06 68.9c-.18.94-.15 1.99-.01 2.93 0 .01 0 .02-.01.03l-.03.03s-.08.02-.1-.01c0 0-.01-.02-.01-.03-.34-1.28-.32-2.5.07-3.68.05-.14.09-.14.11 0 .04.23.04.47 0 .72zM78.3 70.64l.91 2.03c.03.08.03.16 0 .23-.36.67-.83 1.26-1.41 1.77-.04.04-.1.06-.16.05l-2.5-.13a.15.15 0 01-.15-.11l-.57-1.45a.184.184 0 01.03-.2l1.51-1.68c.05-.06.12-.1.2-.12l1.92-.5c.09-.02.19.02.23.11zM70.19 73.04c.52-.28 1.1-.65 1.67-.85.05-.02.11-.02.15 0l2.02.77c.06.02.11.07.13.13l.59 1.46c.02.06 0 .13-.04.17l-1.54 1.37s-.09.06-.15.06c-.84.05-2.09-.55-2.81-1.03a.23.23 0 01-.11-.2v-1.75c0-.06.02-.1.07-.13zM92.4 80.47c0 .1.04.12.11.05.55-.55 1.22-.8 2-.77 1.55.06 2.53.83 2.94 2.3.35 1.26.25 3.02-.79 3.94-1.26 1.13-3.14 1.21-4.33-.09-.1-.1-.14-.09-.13.05l.04.57c0 .08-.05.15-.13.16h-1.75s-.08-.03-.08-.08c0-3.13-.01-6.25-.02-9.36 0-.33 0-.67.03-1.03 0-.05.05-.1.1-.1l1.91.02c.06 0 .09.03.09.09v4.24zm3.2 2.84c0-.93-.75-1.69-1.69-1.69s-1.69.75-1.69 1.69.75 1.69 1.69 1.69 1.69-.75 1.69-1.69zM108.53 86.6s-.04.09-.09.09h-1.95s-.09-.04-.09-.09V76.23s.04-.09.09-.09h1.95s.09.04.09.09V86.6zM112.28 86.59c0 .06-.04.1-.1.1h-1.93c-.06 0-.1-.04-.1-.1V76.24c0-.06.04-.1.1-.1h1.93c.06 0 .1.04.1.1v10.35zM61.47 82.93v3.68s-.04.09-.09.09l-2.05-.02s-.09-.04-.09-.09v-9.67s.04-.09.09-.09h6.49s.09.04.09.09v1.82s-.04.09-.09.09h-4.27s-.09.04-.09.08v1.83s.04.09.09.09h3.93s.09.05.09.1v1.83s-.05.09-.09.09h-3.93s-.09.04-.09.08z"
      ></path>
      <path
        fill="#fc1817"
        strokeWidth="0"
        d="M30.31 84.37c-.26.39-.51.79-.74 1.19-1.83 3.14-3.66 6.32-5.49 9.54-.02.03 0 .07.03.09h.03c2.03.01 4.04.02 6.02.01 2.71 0 3.77 3.41 1.26 4.74-.3.16-.62.24-.98.24-3.38.02-6.78.03-10.18.01-.74 0-1.27-.08-1.61-.24-.64-.3-1.08-.77-1.3-1.42-.35-.99-.03-1.71.48-2.6 3.36-5.85 6.81-11.7 10.04-17.35.49-.85 1.04-1.6 2.06-1.71 1.74-.19 2.29.77 3.03 2.04 3.08 5.29 6.2 10.69 9.37 16.18.04.08.13.13.22.13.84 0 1.64 0 2.42.02.79.01 1.41-.07 1.87-.24 1.09-.42 1.83-1.22 2.2-2.39.13-.4.2-.89.21-1.47.06-2.86.14-5.95.21-9.28 0-.04-.03-.07-.07-.07-.84-.03-1.69-.04-2.56-.02-1.45.03-2.47-.47-2.81-1.94-.15-.62-.04-1.23.31-1.84.44-.76 1.16-1.15 2.17-1.16 1.32-.02 3.16-.02 5.52 0 1.12 0 2 .67 2.35 1.68.11.31.15.8.13 1.47-.11 3.33-.21 6.66-.3 9.97-.02.72-.05 1.46-.09 2.2-.09 1.73-.69 3.31-1.81 4.74-1.62 2.07-3.96 3.27-6.6 3.31-2.67.04-4.39.02-5.14-.08-.79-.1-1.39-.52-1.81-1.25-2.38-4.15-4.84-8.41-7.37-12.77-.35-.6-.68-1.18-1.01-1.75 0-.01-.03-.02-.05 0z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M87.34 79.91h1.58c.06-.01.11.03.11.09v1.48c0 .07-.04.11-.11.11h-1.59c-.06 0-.11.05-.11.11v2.38c0 .21.04.41.13.6.22.53 1.08.48 1.52.32.11-.04.17 0 .17.12v1.42c-.01.08-.07.15-.15.17-1.15.27-3.24.31-3.69-1.18-.09-.28-.13-.6-.12-.96.01-.95.02-1.88.02-2.78 0-.12-.1-.21-.21-.21l-1.04.03c-.07 0-.1-.03-.1-.1l-.02-1.49c0-.06.05-.11.11-.12h1.14c.08 0 .12-.04.12-.12v-1.81s.03-.09.08-.09h1.88c.08 0 .14.06.14.14v1.76c0 .07.07.13.14.13zM74.52 83.31c0 1.98-1.72 3.58-3.82 3.57-2.1 0-3.8-1.62-3.79-3.6 0-1.98 1.72-3.58 3.82-3.57 2.1 0 3.8 1.62 3.79 3.6zm-2.2-.22c-.01-.81-.69-1.46-1.5-1.45h-.29c-.81.02-1.46.69-1.45 1.5v.4c.02.81.69 1.46 1.5 1.45h.29c.81-.02 1.46-.69 1.45-1.5v-.4zM83.08 83.29c0 1.98-1.7 3.59-3.8 3.6-2.11 0-3.82-1.59-3.83-3.57 0-1.98 1.7-3.59 3.8-3.6 2.11 0 3.82 1.59 3.83 3.57zm-3.81 1.74c.91 0 1.65-.78 1.64-1.72 0-.95-.75-1.71-1.66-1.7-.91 0-1.65.78-1.64 1.72s.75 1.71 1.66 1.7zM103.07 82.28c0-.29-.1-.52-.28-.68-.75-.66-1.81-.43-2.5.22-.14.14-.28.13-.41-.01l-.79-.86c-.08-.09-.07-.17.02-.24.99-.8 2.26-1.1 3.81-.88 1.59.22 2.14 1.52 2.16 2.98.02 1.24.03 2.5.03 3.77 0 .06-.05.11-.11.11h-1.77c-.07 0-.12-.05-.12-.12v-.49c0-.12-.04-.14-.14-.06-.2.18-.36.39-.6.5-.99.46-1.94.45-2.85-.03-.74-.4-1.11-1.33-.93-2.16.19-.88.79-1.45 1.81-1.69.75-.18 1.6-.26 2.55-.24.08 0 .12-.04.12-.12zm-1.85 3.07c1.1.12 1.98-.25 1.9-1.5 0-.03-.03-.06-.06-.07-.65-.07-1.82-.04-2.3.49-.41.44-.06 1.03.47 1.08zM61.47 96.38v3.68c0 .05-.04.09-.09.09h-2.03c-.05 0-.09-.05-.09-.1v-9.72c0-.05.04-.09.09-.09h6.47c.05 0 .09.04.09.09v1.86c0 .05-.05.09-.1.09h-4.25a.09.09 0 00-.09.09v1.78c0 .05.05.09.1.09h3.92c.05-.01.09.03.09.08v1.88c0 .05-.05.09-.1.09l-3.91-.02a.09.09 0 00-.09.09zM82.23 93.25l.03-1.86c0-.06.03-.09.09-.09h1.9c.06 0 .08.03.08.09v1.84c0 .1.05.15.15.14l1.65-.02s.06.02.06.06v1.52c0 .06-.02.09-.09.09h-1.65c-.06-.01-.1.01-.1.08-.04.94-.03 1.79.03 2.55.07 1.01 1.02 1.02 1.75.75.03-.01.07 0 .08.04v.02l-.03 1.59c0 .05-.04.1-.09.11-1.46.35-3.83.27-3.83-1.86v-3.18c0-.08-.04-.12-.12-.12l-1.16.02s-.09-.04-.09-.08l.03-1.47c0-.09.05-.14.14-.14l1.05.03c.09 0 .13-.04.14-.13zM71.45 99.5c0-.18-.05-.2-.16-.06-.89 1.13-2.9 1.17-3.88.16-.56-.57-.69-1.3-.4-2.19.48-1.48 3.06-1.66 4.3-1.59.08 0 .11-.03.1-.11-.18-1.48-2.08-1.24-2.85-.42-.11.11-.21.11-.32 0l-.82-.9c-.1-.11-.09-.21.03-.3 1.05-.78 2.29-1.06 3.73-.84 1.93.29 2.2 1.87 2.21 3.5v3.28c0 .07-.04.11-.11.11h-1.73c-.08 0-.12-.04-.12-.12l.02-.53zm-.12-2.34c-.71-.01-2.28 0-2.44.85-.22 1.22 2.71 1.24 2.54-.75 0-.06-.04-.09-.1-.09zM78.3 95.05c-1.4.11-1.99 1.64-1.26 2.73.25.36.65.59 1.2.67.43.06.84-.16 1.12-.48.03-.03.07-.03.1 0l1.18 1.25c.13.14.12.27-.03.38-1.98 1.53-5.54.57-5.92-2.12-.23-1.61.22-2.81 1.36-3.61 1.19-.83 3.42-1.01 4.57.05.12.11.12.29.01.4l-1.13 1.15c-.07.07-.14.07-.2 0-.27-.32-.6-.46-1-.43zM94.6 96.75c0 1.99-1.71 3.6-3.81 3.6s-3.81-1.61-3.81-3.6 1.71-3.6 3.81-3.6 3.81 1.61 3.81 3.6zm-3.81 1.71c.92 0 1.66-.78 1.66-1.73s-.76-1.71-1.68-1.7-1.66.78-1.66 1.73.76 1.71 1.68 1.7zM98.06 94.2c.08-.12.14-.27.25-.37.52-.53 1.21-.73 2.08-.6.1.01.15.07.15.17l.02 1.65s-.04.09-.08.09h-.02c-.65-.15-1.23-.13-1.72.08-.64.26-.81.97-.82 1.62-.02 1.11-.03 2.18-.02 3.23 0 .05-.04.09-.09.09h-1.89c-.06 0-.11-.04-.11-.11v-6.59s.04-.09.09-.09l1.89-.02c.08 0 .12.04.12.12v.68c0 .22.05.24.17.05zM104.91 97.56l1.32-4.05c.04-.11.14-.18.25-.17.64.04 1.26.04 1.86 0 .06 0 .1.04.11.09v.04c-.69 1.77-1.4 3.56-2.11 5.36-.45 1.15-.84 2.31-1.37 3.43-.37.76-.95 1.12-1.8 1.21-.74.07-1.44.02-2.12-.16-.07-.02-.1-.06-.09-.14l.23-1.54s.05-.08.1-.07h.02c.49.18 1.41.33 1.8-.14.29-.34.48-.73.59-1.17.02-.07.01-.14-.02-.2l-2.85-6.57c-.02-.05 0-.11.05-.14h.04l1.9.02c.17 0 .28.08.34.23l1.53 3.96c.08.21.16.21.23 0z"
      ></path>
    </svg>
  );
};

// Future Captain Sports Icon
export const FcSportsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="max-w-[100px] md:max-w-[142px]"
      width="142"
      height="115"
      fill="none"
      viewBox="0 0 130 105"
    >
      <path
        fill="#8e97a8"
        strokeWidth="0"
        d="M18.46 43.46c-.58-7.95.15-15.78 2.18-23.48.58-2.21 1.29-4.37 2.14-6.48.02-.04.05-.06.09-.06 6.77.02 13.58-.61 20.2-2.07 5.26-1.15 10.42-2.89 15.21-5.36 2.36-1.22 4.69-2.66 6.66-4.4.02-.02.03-.04.02-.06v-.04c0-.02.02-.03.03-.03.02 0 .03.02.03.03v.03s0 .04.02.06c1.17 1 2.4 1.9 3.71 2.71 6.18 3.82 13.27 6.16 20.38 7.49a93.833 93.833 0 0018.01 1.62c.04 0 .08.03.1.07.65 1.62 1.22 3.28 1.71 4.98a71.24 71.24 0 012.61 24.99c0 .03.01.05.04.05h17.67s.04.02.04.04v.02l-5.63 11.23s-.02.07 0 .1l5.58 11.61s0 .03-.01.03h-9.66s-.05.02-.05.05v3.81s-.02.05-.05.06c-6.07.96-12.12 2.07-18.17 3.13-.05 0-.09.04-.12.08-8.99 13.42-21.95 22.86-36.21 30.01-.01 0-.02 0-.02-.01 0 0 0-.02-.01-.03 0-.01-.01-.02-.02-.02-14.09-6.96-27.2-16.61-36.03-29.83a.2.2 0 00-.12-.08l-17.72-3.03c-.44-.08-.97-.13-1.45-.21-.03 0-.05-.03-.05-.06v-3.82s-.02-.05-.05-.05H.39s-.02-.01-.03-.02v-.01L5.94 54.9s.02-.07 0-.1L.31 43.55s0-.05.03-.05h18.07s.04-.02.04-.05z"
      ></path>
      <path
        fill="none"
        stroke="#93d5f0"
        strokeWidth="2"
        d="M101.62 16.21c.39.87.68 1.55.87 2.06 2.12 5.75 3.16 11.7 3.1 17.84 0 .49-.04 1.03-.06 1.55-.12 3.44-.7 6.88-1.63 10.19"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        stroke="#2290ce"
        strokeWidth="2"
        d="M64.96 40.65l-.02-15.76"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        stroke="#93d5f0"
        strokeWidth="2"
        d="M64.94 24.89v-8.85"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        stroke="#2290ce"
        strokeWidth="2"
        d="M64.93 16.04l.02-10.36"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        stroke="#8ebadd"
        strokeWidth="2"
        d="M64.93 16.04H46.41s-.05.02-.05.05v7.96s.02.05.05.05h1.14s.06.02.06.06v7.71s-.02.07-.07.07h-1.12s-.05.02-.05.05v7.96s.02.05.05.05h12.6s.06-.02.06-.06v-7.05s.02-.04.04-.04h3.02s.04-.02.04-.04v-7.86s.02-.06.06-.06h2.71M25.82 47.75c-1.53-5.42-1.96-11.06-1.5-16.5.44-5.18 1.67-10.37 3.78-15.13M48.33 77.05c5.2 3.6 10.78 6.61 16.56 9.15.03.01.06 0 .08-.01 0 0 .02-.02.02-.03"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        stroke="#93d5f0"
        strokeWidth="2"
        d="M64.99 86.16c5.72-2.52 11.24-5.51 16.39-9.06"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="none"
        stroke="#2290ce"
        strokeWidth="2"
        d="M64.97 79.9v6.27"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill="#27aae0"
        strokeWidth="0"
        d="M101.62 16.21c.39.87.68 1.55.87 2.06 2.12 5.75 3.16 11.7 3.1 17.84 0 .49-.04 1.03-.06 1.55-.12 3.44-.7 6.88-1.63 10.19l-38.94-7.2-.02-15.76v-8.85l.02-10.36c-.03-.03-.02-.06.02-.09.03-.02.05-.02.07 0 .1.11.18.18.26.24 2.88 1.99 6.03 3.6 9.3 4.95 8.52 3.5 17.68 5.22 26.89 5.34.03 0 .06.01.08.04l.04.05z"
      ></path>
      <path
        fill="#1c75bb"
        strokeWidth="0"
        d="M64.96 5.68l-.02 10.36H46.42s-.05.02-.05.05v7.96s.02.05.05.05h1.14s.06.02.06.06v7.71s-.02.07-.07.07h-1.12s-.05.02-.05.05v7.96s.02.05.05.05h12.6s.06-.02.06-.06v-7.05s.02-.04.04-.04h3.02s.04-.02.04-.04v-7.86s.02-.06.06-.06h2.71l.02 15.76c-.13-.02-.24-.05-.37-.02-12.92 2.37-25.84 4.75-38.77 7.12-1.53-5.42-1.96-11.06-1.5-16.5.44-5.18 1.67-10.37 3.78-15.13 4.43-.04 8.84-.44 13.24-1.19 4.65-.8 9.17-2.06 13.55-3.8 3.54-1.4 7.01-3.17 10.07-5.45z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M64.93 16.04v8.85h-2.71c-.04 0-.06.02-.06.06v7.86s-.02.04-.04.04H59.1s-.04.02-.04.04v7.05s-.02.06-.06.06H46.4s-.05-.02-.05-.05v-7.96s.02-.05.05-.05h1.12s.07-.02.07-.07v-7.71s-.02-.06-.06-.06h-1.14s-.05-.02-.05-.05v-7.96s.02-.05.05-.05h18.52zM75.1 24.14v7.75s.02.04.04.04h.8s.04-.02.04-.04v-3.02s.02-.04.05-.04h9.02s.04.02.04.04v6.83s0 .02-.01.03l-4.26 4.25s-.02.01-.03.01H70.31s-.02 0-.03-.01l-4.26-4.24s-.01-.02-.01-.03V20.35s0-.02.01-.03l4.26-4.27s.02-.01.03-.01h10.48s.02 0 .03.01l4.26 4.27s.01.02.01.03v6.96s-.02.04-.04.04h-9.02s-.04-.02-.04-.04v-3.17s-.02-.04-.04-.04h-.81s-.04.02-.04.04zM28.1 16.12c-2.12 4.76-3.34 9.95-3.78 15.13-.46 5.44-.03 11.09 1.5 16.5l-2.24.41s-.05 0-.05-.04c-1.77-8.46-1.39-17.28.84-25.62.57-2.14 1.3-4.24 2.16-6.29.01-.03.03-.04.06-.04.49.03.99.01 1.51-.06zM103.9 47.85c.93-3.31 1.51-6.75 1.63-10.19.02-.52.06-1.06.06-1.55.05-6.14-.98-12.08-3.1-17.84-.19-.51-.48-1.2-.87-2.06-.02 0-.02 0-.01-.02 0-.01.02-.02.03-.02l1.79.02s.05.02.07.04c.4.93.72 1.72.94 2.36 3.3 9.51 4.12 19.82 2.02 29.67 0 .04-.03.05-.06.04l-2.49-.46z"
      ></path>
      <path
        fill="#8e97a8"
        strokeWidth="0"
        d="M54.97 30.36v3.26s.02.04.04.04h2.31s.04.02.04.04v4.56s-.02.04-.04.04h-9.19s-.04-.02-.04-.04V33.7s.02-.04.04-.04h1.16s.04-.02.04-.04V22.43s-.02-.04-.04-.04h-1.16s-.04-.02-.04-.04v-4.57s.02-.04.04-.04h15.08s.04.02.04.04v5.35s-.02.04-.04.04h-4.57s-.04-.02-.04-.04v-.71s-.02-.04-.04-.04h-3.55s-.04.02-.04.04v3.23s.02.04.04.04h.78s.04-.02.04-.04v-.72s.02-.04.04-.04h4.54s.04.02.04.04v6.16s-.02.04-.04.04h-4.54s-.04-.02-.04-.04v-.74s-.02-.04-.04-.04h-.78s-.04.02-.04.04zM74.09 33.64c.9.02 1.8.02 2.7 0 .17 0 .3-.04.41-.12.21-.15.51-.42.51-.71V30.6c0-.03.02-.05.05-.05h5.55s.06.02.06.06v4.34s-.01.06-.03.08l-3.18 3.18s-.11.07-.18.07h-8.89s-.09-.02-.13-.05l-3.21-3.19s-.03-.05-.03-.08V21.13c0-.05.02-.1.06-.14l3.21-3.21s.04-.03.07-.03h8.89c.09 0 .17.03.23.09l3.14 3.15s.06.08.06.13v4.44s-.03.06-.06.06H77.8s-.08-.03-.08-.08v-2.45s-.02-.09-.05-.13l-.56-.57s-.04-.03-.06-.03h-2.94s-.07.01-.09.04l-.59.59s-.03.05-.03.08v9.89s0 .04.03.06l.59.56s.06.04.1.04z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M64.96 76.16l-53.88-7.39s-.05-.02-.05-.06V52.39s.01-.05.04-.05c5.37-.82 10.37-1.53 16.12-2.39 12.38-1.85 24.75-3.69 37.13-5.54.31-.05.68-.02 1.04.04 17.55 2.64 35.11 5.25 52.66 7.89.03 0 .05.03.05.05v16.27c-.01.06-.05.1-.11.11l-52.82 7.38h-.17z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M7.63 54.91a.34.34 0 000-.2l-3.24-9.23s0-.08.05-.09h13.87s.09.03.1.08c.28 1.17.52 2.13.69 3.48 0 .03-.01.05-.04.06-3.15.57-6.29 1.18-9.45 1.69-.03 0-.05.03-.05.06v13.83s-.03.06-.06.06l-5.11-.02s-.02 0-.02-.02 3.27-9.71 3.27-9.71zM119.5 50.69c-2.87-.44-5.73-1.02-8.59-1.54-.03 0-.04-.02-.03-.05l.5-3.63c0-.05.05-.09.1-.09h13.23s.05.02.05.05v.01l-2.8 9.3s-.01.08 0 .12l3.27 9.72s0 .05-.03.05l-5.6.02s-.07-.03-.07-.07V50.73s-.01-.03-.03-.04z"
      ></path>
      <path
        fill="#1c75bb"
        strokeWidth="0"
        d="M66.39 55.85h-.93s-.05-.02-.05-.05v-3.82s.02-.05.05-.05h10.31c.19 0 .34.06.47.19.83.84 1.66 1.68 2.49 2.51.04.04.06.09.06.14v4.24s-.01.07-.04.09l-1.05 1.05s-.03.05 0 .08l1.03.98s.07.1.07.16v3.66s.02.05.05.05h.93s.05.02.05.05v3.79s-.04.07-.07.07h-5.65s-.03 0-.03-.03v-6.19s-.01-.06-.04-.08l-.48-.48s-.06-.04-.1-.04h-2.24s-.05.01-.05.04v2.81s.02.05.05.05h.93s.05.02.05.05v3.84s-.01.03-.03.03h-6.7s-.05-.02-.05-.05v-3.82s.02-.05.05-.05h.93s.05-.02.05-.05v-9.13s-.02-.05-.05-.05zM27 58l.41.37c.07.06.16.1.25.1h4.75c.09 0 .17.03.23.09l2.6 2.63s.05.07.05.11v4.89s-.02.07-.04.1l-2.66 2.68s-.04.03-.07.03h-7.38c-.09 0-.18-.03-.25-.1l-2.6-2.6s-.04-.05-.04-.09V63s.01-.02.02-.02h4.64s.05.02.05.05v1.43s.02.09.05.12l.39.39c.07.07.16.11.26.11h2.15c.3 0 .5-.3.7-.49.03-.03.04-.06.04-.1v-1.52s-.01-.07-.04-.1l-.45-.47s-.06-.04-.1-.04h-4.85a.29.29 0 01-.23-.1l-2.59-2.57s-.05-.08-.05-.12V54.7s.02-.09.05-.12l2.64-2.63s.07-.04.11-.04h7.31c.12 0 .24.04.32.13l2.55 2.48s.06.08.06.13v3.13s-.02.06-.06.06H30.6s-.03-.01-.03-.03v-1.43s-.03-.08-.06-.11l-.42-.38s-.09-.06-.14-.06h-2.31c-.09 0-.17.03-.24.1l-.4.38s-.04.06-.04.1v1.47s.02.07.04.09zM37.48 55.85h-.93s-.05-.01-.05-.05v-3.84s.01-.03.03-.03h10.39c.12 0 .23.05.33.15.87.84 1.72 1.67 2.56 2.51.04.04.06.09.06.15v4.95c0 .06-.02.1-.06.14l-2.6 2.57a.31.31 0 01-.22.09H42.3s-.05.01-.05.04v2.51s.02.05.05.05h.93s.05.02.05.05v3.84s-.01.03-.03.03h-6.73s-.02-.01-.02-.02v-3.84s.02-.05.05-.05h.93s.05-.02.05-.05v-9.13s-.02-.05-.05-.05zM61.43 68.94s-.11.07-.18.07h-7.13c-.24 0-.35-.03-.53-.21-.83-.81-1.65-1.63-2.45-2.44a.273.273 0 01-.08-.19V54.72s.01-.05.03-.07L53.73 52s.1-.07.16-.07h7.28c.12 0 .24.04.32.13l2.56 2.57s.04.07.04.1v11.48s-.02.08-.05.12l-2.62 2.6zM84.74 55.9v.85s-.02.04-.04.04h-3.78s-.04-.02-.04-.04v-4.77s.02-.04.04-.04h14.42s.04.02.04.04v4.77s-.02.04-.04.04h-3.78s-.04-.02-.04-.04v-.85s-.02-.04-.04-.04h-.94s-.04.02-.04.04v9.15s.02.04.04.04h.96s.04.02.04.04v3.83s-.02.04-.04.04h-6.71s-.04-.02-.04-.04v-3.83s.02-.04.04-.04h.95s.04-.02.04-.04V55.9s-.02-.04-.04-.04h-.95s-.04.02-.04.04zM100.96 56.42v1.49s.01.06.04.08l.45.4c.05.04.11.07.18.07h4.8c.07 0 .14.03.2.08l2.59 2.63s.07.1.07.16v4.86s-.02.07-.04.1l-2.59 2.6c-.07.07-.17.11-.27.11h-7.23c-.12 0-.23-.05-.32-.14l-2.53-2.54s-.06-.1-.06-.16v-3.17s.01-.02.02-.02h4.63s.06.03.06.06v1.44s.02.07.05.1l.43.42c.05.05.12.08.2.08h2.18c.31 0 .51-.29.7-.49.02-.03.04-.06.04-.09v-1.51s-.01-.07-.04-.1l-.41-.43s-.11-.08-.18-.08h-4.8c-.11 0-.23-.07-.35-.2-.79-.84-1.65-1.63-2.44-2.44a.278.278 0 01-.08-.21v-4.81s.02-.09.05-.12L98.92 52a.28.28 0 01.2-.08h7.28a.4.4 0 01.29.12l2.54 2.47s.08.11.08.18v3.1s-.02.06-.06.06h-4.6s-.06-.01-.06-.06v-1.41s-.01-.06-.04-.09l-.45-.42s-.06-.04-.1-.04h-2.38c-.05 0-.1.02-.14.05l-.46.43s-.04.05-.04.08z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M42.25 55.91s.02-.05.05-.05h1.96c.49 0 .89.37.89.82v1.07c0 .45-.4.82-.89.82H42.3s-.05-.02-.05-.05v-2.6zM59.33 64.56c-.14.25-.44.53-.75.53-.7 0-1.41 0-2.12-.01a.31.31 0 01-.22-.09l-.42-.4s-.05-.06-.05-.1v-8.04s.01-.06.04-.09l.45-.44s.11-.07.17-.07h2.18c.35 0 .49.28.72.5.03.03.05.06.05.11v7.96c0 .05-.02.11-.04.16zM71.16 55.91s.02-.06.05-.06h1.94c.51 0 .92.39.92.88v.65c0 .49-.41.88-.91.88h-1.94s-.05-.02-.06-.05v-2.3zM48.33 77.05c5.2 3.6 10.78 6.61 16.56 9.15.03.01.06 0 .08-.01 0 0 .02-.02.02-.03 5.72-2.52 11.24-5.51 16.39-9.06.06-.05.12-.07.16-.08 3.21-.57 6.42-1.13 9.64-1.68.05 0 .05 0 .02.04-7.51 7.42-16.59 13.1-26.15 17.51-.03.01-.06.01-.09 0-9.49-4.36-18.61-10.03-26.06-17.42-.03-.03-.03-.04.02-.04l9.4 1.62z"
      ></path>
      <path
        fill="#1c75bb"
        strokeWidth="0"
        d="M64.97 79.9v6.3c-.02.02-.05.03-.08.01-5.77-2.55-11.36-5.55-16.56-9.15l16.65 2.84z"
      ></path>
      <path
        fill="#27aae0"
        strokeWidth="0"
        d="M81.38 77.1c-5.15 3.54-10.68 6.54-16.39 9.06v-6.27c5.43-.93 10.87-1.88 16.31-2.84h.05c.01 0 .02.02.03.04z"
      ></path>
    </svg>
  );
};

// MSA (Major Sports Analysis) Icon
export const MsaIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="max-w-[140px] md:max-w-[200px]"
      width="332"
      height="130"
      viewBox="0 0 332 130"
      fill="none"
    >
      <path
        // fill="#ee1c25"
        fill="#ec534c"
        strokeWidth="0"
        d="M37.04 2.8h77.29c3.88.22 7.67.87 11.37 1.96 3.55 1.03 6.69 2.65 9.42 4.84 6.78 5.43 8.4 16.32 7.25 24.45-1.43 10.07-2.83 19.96-4.2 29.67-.02.16.05.25.22.25 17.62-.01 35.33 0 53.12 0 .79 0 2.2-.29 2.71-.77 1.21-1.16 1.15-2.65-.4-3.33-.64-.28-1.24-.59-1.9-.82-8.35-2.88-16.61-5.71-24.78-8.48-3.59-1.22-6.83-2.82-9.71-4.8-4.04-2.78-6.26-6.67-6.65-11.66-.99-12.67 4.17-28.24 18.59-30.66 1.84-.31 3.7-.52 5.58-.63h129.3c1.28.12 2.54.27 3.8.45 3.1.44 5.99 1.36 8.68 2.78 9.69 5.13 11.22 16.32 9.86 26.14a6278.94 6278.94 0 01-5.42 38.21c-1.2 8.28-6.04 14.23-14.58 15.63-1.33.22-2.79.33-4.37.33-18.11.02-35.81.02-53.1 0-2.97 0-5.67-.49-8.1-1.45-9.04-3.58-9.04-15.09-8.14-23.12.66-5.83 1.54-11.54 4.02-16.58 3.95-8.01 10.97-11.48 19.94-11.5 12.17-.02 24.95-.02 38.33 0 .15 0 .25-.07.27-.22 1.22-6.15-2.28-9.14-8.17-9.14H182.85c-.81 0-2.47.07-2.91.92-.72 1.4.2 2.14 1.4 2.52 1.98.63 3.83 1.59 5.81 2.29 6.88 2.45 13.81 4.89 20.79 7.32 3.58 1.25 6.75 2.59 9.49 4.03 10.36 5.43 11.15 16.44 8.74 26.86-2.06 8.91-7.49 15.65-16.68 17.58-1.77.37-4.34.56-7.72.55-34.8-.04-67.36-.04-97.67 0-.09 0-.12-.04-.11-.13 2.26-15.87 4.5-31.76 6.73-47.65.36-2.56.27-4.94-.27-7.15-1.13-4.58-5.37-6.56-9.75-6.77-1.44-.07-2.9-.08-4.37-.04-.14 0-.21.07-.23.21l-8.69 61.34c-.02.11-.11.19-.23.19H56.62c-.14 0-.2-.07-.18-.21l8.69-61.34c.02-.14-.04-.22-.19-.22-3.87.01-7.75.02-11.63 0-1.56 0-3.85.39-4.59 1.96-.41.88-.69 1.79-.82 2.74a52378.4 52378.4 0 00-8.06 56.85c-.02.14-.1.21-.25.21H9.04c-.14 0-.21-.07-.19-.22 3.16-22.36 6.42-45.32 9.77-68.9 1.05-7.4 6.94-12.88 14.25-14.04.97-.15 2.36-.29 4.17-.43zm238.12 52.55l-8.28 1.15c-.18.03-.21.11-.09.25l5.04 5.7c.1.12.13.25.08.41l-2.58 8.21s0 .06.04.08h.04l7.98-3.9c.11-.05.24-.05.34 0l6.85 3.9s.09.01.12-.03c0-.02.01-.03.01-.05-.07-2.2-.14-4.37-.22-6.52-.02-.6 0-1.22.04-1.84.01-.12.06-.22.15-.29l6.63-5.69c.14-.12.12-.19-.06-.22l-7.85-1.17a.47.47 0 01-.41-.34l-2.55-7.26c-.02-.06-.1-.1-.16-.07-.02 0-.04.03-.06.05l-4.68 7.37c-.09.14-.22.23-.39.25z"
      ></path>
      <path
        fill="#fff"
        strokeWidth="0"
        d="M53.2 99.04c-.8-.59-.89-1.84-.2-2.78.69-.94 1.91-1.22 2.71-.63s.89 1.84.2 2.78c-.69.94-1.91 1.22-2.71.63zM261.77 117.86h1.78c.18 0 .29.09.33.27l.23 1.25c.04.21-.08.4-.27.47-1.32.45-2.61.56-3.89.34-1.55-.27-1.78-1.65-1.6-2.94 1-7.17 2.01-14.35 3.04-21.55.03-.21.21-.36.41-.36h2.11c.27 0 .38.13.34.39-.95 6.8-1.88 13.53-2.82 20.18-.09.66-.1 1.21-.04 1.64.03.19.19.32.37.32zM301.87 99.05c-.81-.59-.91-1.83-.22-2.78.69-.95 1.9-1.23 2.71-.64s.91 1.83.22 2.78c-.69.95-1.9 1.23-2.71.64zM105.24 95.95c.09-.01.18-.04.25-.1a.49.49 0 01.26-.1c1.03-.07 2.35-.01 3.95.19 1.67.21 3.09.55 4.28 1.03.14.06.19.16.14.31l-.66 1.73c-.14.36-.38.47-.74.32-2.13-.9-4.34-1.28-6.66-1.13-2.42.15-4.45 2.35-3.25 4.72.74 1.47 4.25 2.9 5.81 3.61 2.59 1.17 5.13 3.03 5.29 6.07.32 6.46-5.56 8.15-10.76 7.62-.93-.09-1.83-.21-2.7-.34-1.15-.17-2.31-.53-3.48-1.07-.21-.1-.26-.25-.16-.45l.94-1.88c.1-.19.33-.27.52-.18 2.57 1.24 5.13 1.75 7.68 1.56 2.65-.2 4.93-1.37 4.65-4.48-.12-1.29-.89-2.31-2.32-3.03-1.65-.84-3.28-1.68-4.88-2.51-2.06-1.07-4.07-2.68-4.2-5.21-.16-3.11 1.24-5.22 4.22-6.32.54-.2 1.03-.3 1.5-.31.11 0 .22-.01.33-.02zM25.14 101.81c-2.47 4.71-5.03 9.47-7.66 14.27-.74 1.34-1.88.97-3.13.96-.44 0-.83-.31-.94-.74l-3.67-13.94c-.14-.53-.25-.52-.33.02L7 119.45c-.03.24-.24.42-.48.42H4.5c-.27 0-.38-.14-.34-.4 1.07-7.76 2.1-15.1 3.09-22.03.21-1.47 1.64-1.34 2.76-1.33.69 0 1.15.51 1.31 1.14 1.32 5.16 2.7 10.73 4.14 16.69.07.29.17.3.31.04 2.76-5.35 5.72-10.94 8.86-16.8.74-1.37 1.75-.94 2.97-1.07.94-.1 1.34.66 1.22 1.52-.99 7.1-2.01 14.35-3.05 21.75-.04.27-.27.47-.54.47h-1.91c-.33 0-.47-.16-.43-.49l2.48-17.49c.07-.48 0-.5-.23-.08zM214.24 114.24h-8.8c-.15 0-.26.07-.32.21l-2.23 4.88c-.16.37-.45.55-.85.55h-2.22c-.51 0-.66-.23-.43-.69 3.61-7.46 7.17-14.83 10.69-22.11.58-1.21 1.99-.98 3.05-.92.57.03.92.35 1.04.95 1.57 7.88 3.05 15.29 4.43 22.24.05.24-.11.47-.35.52H215.95c-.28 0-.44-.14-.49-.41l-.91-4.98c-.03-.16-.13-.25-.29-.25zm-7.79-2.63c-.04.08 0 .17.08.21.02 0 .04.01.06.01h7.22c.09 0 .16-.08.15-.16v-.02L212 99.87c-.01-.08-.09-.14-.18-.13-.05 0-.1.04-.12.09l-5.25 11.79zM171.11 102.17h3.9c.23 0 .32.11.29.34l-.21 1.34c-.03.22-.16.33-.39.33h-3.94c-.14 0-.21.07-.23.2-.51 3.71-1.03 7.53-1.56 11.47-.15 1.13.27 1.79 1.27 1.98.54.1 1.63.03 3.29-.21.17-.02.33.1.35.27l.24 1.56c.03.19-.05.31-.24.35-1.63.43-3.25.57-4.87.41-.67-.06-1.25-.27-1.75-.6-1.09-.73-1.32-2.21-1.16-3.42.52-3.86 1.06-7.79 1.62-11.79.02-.15-.04-.23-.2-.23h-2.27c-.22 0-.31-.11-.29-.33l.16-1.13c.04-.26.19-.42.45-.47l2.47-.44c.15-.03.25-.11.29-.25l1.01-3.16c.08-.27.26-.45.53-.53l1.28-.42c.26-.08.37 0 .34.29l-.59 4.18c-.02.16.05.24.21.24zM81.71 104.6l-2.16 14.99c-.03.19-.14.29-.33.29H77c-.14 0-.26-.12-.26-.25v-.04c.76-5.5 1.47-10.67 2.15-15.53.28-2.01 1.58-2.31 3.31-2.45.49-.04.97-.08 1.46-.14 1.41-.15 2.8-.17 4.14-.05.16.02.29.16.27.33v.02l-.41 2.51c-.02.14-.13.25-.27.27-1.26.2-2.32-.19-3.56-.18h-1.88c-.16 0-.25.08-.27.23zM157.74 104.62l-2.16 15.07c-.02.12-.09.19-.22.19h-2.32c-.19 0-.27-.09-.25-.28.88-6.5 1.62-11.76 2.2-15.78.14-.97.63-1.59 1.48-1.88.77-.26 1.65-.38 2.65-.36.16 0 .3-.03.44-.09.16-.07.33-.11.5-.11 1.25-.01 2.48-.01 3.7 0 .29 0 .41.15.37.44l-.39 2.42c-.04.27-.2.39-.47.37l-5.15-.29a.361.361 0 00-.38.31zM34.04 119.66c-1.97-.86-3.04-2.44-3.21-4.74-.54-6.88 2.14-13.66 10.22-13.16.86.06 1.74.14 2.61.26.78.11 1.56.27 2.37.49.48.13.69.44.62.94l-2.1 15.22c-.03.22-.18.41-.38.49-1.2.48-2.42.77-3.66.88-.31.03-.62.06-.94.1-2.22.31-4.07.14-5.53-.49zm9.38-15.07c-7.27-1.88-9.79 2.61-9.79 9.02 0 2.46 1.15 4.12 3.85 4.25 1.46.07 2.86-.08 4.19-.46a.33.33 0 00.26-.3l1.68-12.22c.02-.15-.04-.25-.19-.28zM44.98 124.43c3.15-1.08 4.61-2.95 5.04-6.02.75-5.31 1.52-10.8 2.31-16.45.02-.11.11-.19.22-.19h2.43c.1 0 .19.09.19.19v.03c-.78 5.56-1.52 10.87-2.25 15.92-.63 4.39-2.45 7.88-7.18 8.98-.28.07-.47-.04-.56-.31l-.51-1.56c-.08-.25.05-.51.29-.59zM61.22 119.53c-3.17-1.48-3.32-5.32-3.01-8.28.39-3.76 2.24-7.54 5.89-8.93 2.03-.78 4.05-.76 6.06.05 2.22.9 3.38 3.19 3.52 5.52.28 4.48-1.09 9.97-5.56 11.72-2.44.96-4.74.94-6.91-.07zm2.47-1.8c5.89 1.2 7.43-5.45 7.05-9.94-.15-1.78-.93-2.91-2.36-3.38-1.66-.54-3.16-.3-4.51.73-2.39 1.84-3.01 5.54-2.91 8.52.06 1.76.85 3.67 2.72 4.06zM118.45 119.88l-.92 6.42c-.04.27-.2.41-.47.41H115c-.23 0-.33-.11-.3-.34l3.2-22.85c.02-.16.12-.29.27-.36 1.41-.66 2.78-1.05 4.11-1.15.66-.06 1.22-.25 1.89-.26 1.45-.02 2.62.12 3.5.44 2.3.82 3.6 2.63 3.89 5.4.41 3.83-.5 8.29-3.5 10.81-1.89 1.59-4.3 2.19-7.22 1.81-.78-.1-1.51-.25-2.2-.43-.12-.03-.18.01-.2.13zm5.06-15.67c-.93.09-1.85.25-2.75.55-.12.04-.18.12-.2.24l-1.69 12.04c-.02.12.06.25.18.28.68.22 1.37.38 2.09.47 6.1.83 7.73-4.23 7.59-9.07-.09-3.34-1.83-4.84-5.22-4.51zM137.72 119.55c-1.73-.8-2.73-2.26-3.03-4.39-.66-4.79.84-10.79 5.7-12.79a8.05 8.05 0 014.06-.56c1.45.16 2.63.64 3.54 1.41 1.89 1.61 2.3 4.17 2.16 6.58-.21 3.91-1.74 8.27-5.46 9.76-2.48.99-4.8.99-6.98-.01zm2.41-1.82c5.83 1.19 7.37-5.29 7.08-9.77-.13-2-1.03-3.21-2.68-3.64-1.57-.4-2.97-.13-4.2.82-2.41 1.86-3.03 5.56-2.91 8.59.07 1.73.86 3.62 2.72 4zM186.43 104.41a10.65 10.65 0 00-3.17-.2c-2.59.23-3.71 3.37-.96 4.57 1.39.61 2.68 1.21 3.85 1.8 1.65.83 2.82 2.3 2.86 4.22.06 2.82-1.83 4.62-4.49 5.22-1.37.31-2.94.33-4.72.04-1.7-.27-2.95-.63-3.76-1.07-.23-.12-.29-.31-.18-.55l.69-1.56c.11-.24.39-.35.63-.24h.01c2.21 1.08 6.4 2.12 8.32.11 1.37-1.44.52-3.25-1.16-4.03-1.08-.49-2.16-.99-3.25-1.49-1.85-.84-3.28-2.31-3.2-4.37.1-2.58 1.42-4.19 3.96-4.82 2.22-.56 4.63-.36 7.22.59.35.13.45.37.31.71l-.57 1.36c-.13.31-.35.4-.66.26-.56-.25-1.14-.44-1.76-.57zM225.96 104.59l-2.06 14.89c-.03.23-.23.39-.45.39h-2.02c-.29 0-.41-.14-.37-.43.7-4.74 1.36-9.43 1.98-14.07.32-2.4 1.24-3.52 3.75-3.37.28.02.38.02.63-.13.11-.07.23-.1.36-.1h3.24c.17 0 .33.04.48.13.14.08.29.12.46.11.16-.01.33 0 .49.03 3.6.7 4.59 3.78 4.18 7.04-.42 3.4-.9 6.86-1.42 10.39-.04.26-.19.39-.46.39h-2.04c-.19 0-.35-.16-.35-.35v-.05c.55-3.63 1.03-7.12 1.44-10.47.19-1.56-.06-3.58-1.7-4.31-.6-.27-1.22-.42-1.87-.47-1.26-.1-2.63-.04-4.11.21-.1.02-.15.07-.16.17zM243.34 119.7c-2.26-.88-3.3-2.96-3.38-5.3-.16-4.78 1.05-10.19 5.83-12.04 1.49-.58 3.27-.75 5.34-.51.66.08 1.32.15 1.95.22.88.1 1.73.31 2.55.62.12.05.21.17.21.3.01.41-.01.82-.07 1.23-.7 4.68-1.36 9.47-1.98 14.39a.75.75 0 01-.45.58c-.91.36-1.9.62-2.96.78-1.07.16-2.1.27-3.08.33-1.42.08-2.74-.11-3.97-.59zm4.91-15.46c-4.59.58-5.61 6.09-5.39 9.87.13 2.26 1.29 3.49 3.48 3.71 1.49.15 2.99 0 4.52-.43a.33.33 0 00.26-.3l1.68-12.22c.02-.15-.04-.24-.18-.28-1.52-.41-2.97-.52-4.37-.35zM292.67 104.41c-1.09-.24-2.17-.3-3.24-.2-2.63.25-3.6 3.41-.85 4.59 1.42.61 2.76 1.25 4.02 1.91 1.46.78 2.54 2.2 2.62 3.91.14 2.98-1.82 4.82-4.59 5.43-1.32.29-2.86.29-4.61.01-1.72-.28-2.97-.63-3.75-1.07-.23-.13-.29-.31-.19-.56l.7-1.55c.1-.24.38-.34.62-.24h.02c2.14 1.07 6.43 2.13 8.34.09 1.37-1.46.48-3.25-1.2-4.03-2.51-1.17-6.57-2.3-6.42-5.85.11-2.66 1.51-4.29 4.18-4.87 2.22-.49 4.55-.27 6.99.64.29.11.43.43.33.72v.02l-.56 1.34c-.13.31-.35.39-.65.26-.56-.25-1.14-.43-1.73-.56zM316.42 104.41c-1.11-.23-2.18-.3-3.23-.21-2.56.23-3.66 3.34-.97 4.54 1.32.58 2.57 1.18 3.75 1.78 2.47 1.25 3.42 3.16 2.82 5.73-.41 1.76-1.71 2.98-3.89 3.65-1.39.42-3.1.48-5.15.16-1.71-.26-2.96-.62-3.76-1.08-.22-.13-.28-.31-.18-.54l.69-1.55c.11-.24.39-.35.63-.24h.02c2.2 1.1 7.09 2.31 8.66-.38.42-.73.44-1.45.05-2.18-.66-1.23-2.87-2.04-4.14-2.52-1.65-.63-3.69-2.09-3.82-4.03-.2-2.94 1.11-4.77 3.92-5.5 2.16-.56 4.55-.36 7.19.58.29.1.45.43.35.72 0 .01 0 .02-.01.03l-.56 1.34c-.13.31-.35.39-.66.26-.58-.25-1.15-.44-1.72-.56zM271.88 119.65c-.3.05-.61 0-.92-.13a.48.48 0 01-.25-.29c-.13-.44-.24-.91-.32-1.4-.91-5.32-1.78-10.44-2.62-15.37-.03-.19.04-.28.23-.28h2.14c.18 0 .33.13.36.3l2.36 14.7c.06.38.17.39.33.04l6.91-14.97s.07-.08.12-.08l2.68.02s.05.02.05.05v.02c-3.61 7.91-6.95 15.11-10.03 21.6-1.14 2.4-3 3.48-5.57 3.22-1.22-.12-2.49-.43-3.81-.93-.23-.09-.3-.25-.2-.48l.66-1.56c.08-.21.23-.27.44-.19.97.37 1.98.63 3.04.77 1.2.16 2.11-.17 2.72-.99.61-.83 1.24-2.1 1.87-3.81.07-.19 0-.27-.2-.23zM303.79 102.46l-2.4 17.18c-.02.13-.13.23-.26.23h-2.33c-.14 0-.27-.12-.27-.27v-.04l2.4-17.16c.02-.13.13-.23.26-.23l2.32-.02c.14 0 .27.12.27.26v.04z"
      ></path>
    </svg>
  );
};
